import React, { useEffect, useRef, useState, useMemo } from "react";
import styled from "styled-components";
import { Tab } from "../../../../Reusablecomponents/Tab";
import {
  Badge,
  Button,
  Col,
  Row,
  Avatar,
  Checkbox,
  Space,
  Popover,
  Menu,
  Dropdown,
  Tooltip,
  Form,
  Spin,
  message,
  Select,
  InputNumber,
  Input,
  Collapse,
  Upload,
  Card,
} from "antd";
import {
  CloseOutlined,
  DownOutlined,
  MoreOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
  ButtonWhite,
} from "../../../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../../../Reusablecomponents/UITable/UITable";
import { ReactComponent as CopyIcon } from "../../../../assets/images/Vector.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/Editicon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/delete-icon.svg";
import { ReactComponent as BulkDelete } from "../../../../assets/images/BulkDelete.svg";
import { ReactComponent as GeoDelete } from "../../../../assets/images/GeoDelete.svg";
import FilterIcon from "../../../../assets/images/Filter-Icon.svg";
import SortIcon from "../../../../assets/images/sort-svgrepo-com.svg";
import ImportIcon from "../../../../assets/images/download1.svg";
import ExportIcon from "../../../../assets/images/export-svgrepo-com (1).svg";
import GridBuilder from "../../../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../../../Reusablecomponents/UIModal";
import Consignordetails1 from "./ConsignCode";
import { CALL_API } from "../../../../Common/api";
import {
  chargetype,
  priorityType,
  TripTypeEnum,
} from "../../../../Common/constant";
import { useSelector } from "react-redux";
import moment from "moment";
import { EventType } from "../../../../Common/constant";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import LocationPicker from "../../../../Reusablecomponents/LocationPicker/LocationPicker";
import ReusablePagination from "../../../../Reusablecomponents/ReusablePagination";
import axios from "axios";
import { CSVLink } from "react-csv";
import { useLocation, useParams } from "react-router-dom";
import {
  setConsigneeList,
  setConsignerList,
} from "../../../../Redux/AuthSlice";
import { useDispatch } from "react-redux";

const { RangePicker } = DatePicker;

const { Panel } = Collapse;
const { Option } = Select;

export const WrapperBox = styled.div`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 6px 8px !important;
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
  .reposnive_assigned_unassigned_container {
    display: flex;
    flex-direction: column;
    gap: 0px;
    padding: 2px;
  }
  .reposnive_assigned_unassigned_col_two {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .custom_dropdown_select {
    background-color: rgb(174, 191, 177) !important;
  }
  background-color: white;
  /* padding: 3px; */
  border-radius: 8px;
  .consingment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5f6d8c;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
  }
  .FilterIcon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    // border-radius:50%;
    background-color: #ebf7ed !important;
    margin-left: 10px;
  }

  @media (max-width: 320px) {
    .consingment_container {
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #5f6d8c;
    }
    .consingment_container_two {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
  }
  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border: none;
  }

  .bulk_btn {
    width: 170;
    height: 38;
    gap: 8px;
  }
  .bulkcreate_button {
    /* width: 170px; */
    height: 38;
    gap: 8px;
    background-color: rgb(232, 255, 236) !important;
  }
  .bulkcreate_button span {
    display: inline-block;
    font-size: 14px !important;
  }

  .Creating_Consignment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 10px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 15px 8px;
  }
  .ant-badge.ant-badge-status .ant-badge-status-dot {
    width: 12px;
    height: 12px;
  }
  .badg {
    padding: 6px;
  }

  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 7px 0px;
  }
  .flilter_five {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .container_for_assigned_unassigned {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
    margin-left: 15px;
  }
  .datsource_length {
    margin: 16px 0px 20px 0px !important;
  }
  .checkbox_group_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .bulk_btn:focus,
  .bulk_btn:active,
  .bulk_btn:focus-visible {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }
  .Create_btn:focus,
  .Create_btn:active,
  .Create_btn:focus-visible {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  @media (min-width: 481px) and (max-width: 2561px) {
    .bulk_btn {
      width: 180px !important;
      height: 38px !important;
      gap: 8px;
    }
  }

  .ant-tabs-tab {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media screen and (min-width: 481px) and (max-width: 768px) {
    div[tabindex="0"] {
      width: 100% !important;
      height: 0vh !important;
    }
    .ant-tabs .ant-tabs-tab {
      display: inline !important;
    }
  }
`;

const TableStyletwo = styled.div`
  width: 100% !important;
  .footer-btn {
    border-radius: 15px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 10px !important;
    margin: 2px !important;
    border: none !important;
    /* width: 130px !important; */
    border-radius: 60px;
  }
  @media (max-width: 480px) {
    .footer-btn {
      font-size: 15px;
      /* width: 130px !important; */
    }
  }
  .footer_assigntrip {
    background-color: rgb(232, 255, 236) !important;
    color: #2c963d !important;
    border-radius: 25px;
    padding-left: 10px;
    padding-right: 10px;
    width: 145px;
  }

  .bottom-action-bar {
    position: fixed;
    bottom: 0;
    background-color: rgb(246, 246, 246);
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    margin-top: 20px;
    padding: 8px 0;
    border-radius: 12px;
    height: 70px;
  }

  .bottom-action-bar button {
    padding: 8px 8px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    margin-left: 10px;
  }

  .bottom-action-bar button:nth-child(1) {
    /* width: 150; */
    gap: 8px;
    font-weight: 500;
    font-size: 16px;
    color: red;
    background-color: #ffffff;
  }

  .bottom-action-bar button:nth-child(2) {
    /* width: 150;
    height: 38; */
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: #e8ffec !important;
    color: #2c963d !important;
    white-space: nowrap;
  }

  .bottom-action-bar button:nth-child(3) {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
    margin-right: 120px;
    white-space: nowrap;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    .bottom-action-bar button:nth-child(3) {
      font-weight: 400;
      font-size: 12px;
      background-color: rgb(44, 150, 61) !important;
      color: white !important;
    }
    .bottom-action-bar button {
      padding: 4px 7px 4px 7px;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      margin-left: 4px;
    }
    .bottom-action-bar button:nth-child(1) {
      gap: 8px;
      font-weight: 300;
      font-size: 12px;
      color: red;
      background-color: #ffffff;
    }
  }
`;

const TableStyle = styled.div`
  /* .fixed_height_table .ant-table-container {
  height: 300px; 
} */
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 6px 8px !important;
  }

  .datsource_length {
    margin: 5px 0px 5px 0px !important;
  }
  .inactive-status {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #f20000;
  }
  .text-wrap {
    white-space: nowrap !important;
    word-break: break-word; /* Break long words */
    overflow-wrap: break-word; /* Ensure wrapping for long words */
  }
  .red-dot {
    width: 4px;
    height: 4px;
    background-color: #f20000;
    border-radius: 50%;
  }

  .ant-checkbox-inner {
    width: 22px !important;
    height: 22px !important;
    border-radius: 6px !important;
    border: 1.5px solid #d0d5dd !important;
    background-color: #fff !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #2c963d !important;
    border-color: #2c963d !important;
  }

  .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {
    background-color: #fff !important;
    border-color: #d0d5dd !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner {
    border-color: #d0d5dd !important;
  }

  .bottom-action-bar {
    position: fixed;
    bottom: 0;

    background-color: white;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 12px 12px;
  }

  .bottom-action-bar button {
    padding: 8px 16px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    margin-left: 10px;
  }

  .bottom-action-bar button:nth-child(1) {
    width: 150;
    height: 38;
    gap: 8px;
    font-weight: 500;
    font-size: 16px;
    color: red;
    background-color: #ffffff;
  }

  .bottom-action-bar button:nth-child(2) {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: #e8ffec !important;
    color: #2c963d !important;
  }

  .bottom-action-bar button:nth-child(3) {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
    margin-right: 120px;
  }
`;

const Consignment1 = () => {
  const latlongList = useSelector((state) => state?.authTracking?.latlongList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const driverWithVehicle = useSelector(
    (state) => state?.authTracking?.driverWithVehicle,
  );
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);

  const driverList = useSelector((state) => state?.authTracking?.driverList);

  const countryList = useSelector((state) => state?.authTracking?.countryList);

  const location = useLocation();

  const { consignmentRecord } = location.state || {};
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("CONSIGN", "CRC"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("CONSIGN", "UPC"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("CONSIGN", "DC"),
    [reduxPermissions],
  );
  const copyAllowed = useMemo(
    () => hasPermission("CONSIGN", "CYC"),
    [reduxPermissions],
  );
  const importAllowed = useMemo(
    () => hasPermission("CONSIGN", "IC"),
    [reduxPermissions],
  );
  const exportAllowed = useMemo(
    () => hasPermission("CONSIGN", "EX"),
    [reduxPermissions],
  );
  const assignAllowed = useMemo(
    () => hasPermission("CONSIGN", "CAT"),
    [reduxPermissions],
  );
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [pageSize, setPageSize] = useState(10);
  const [filterCount, setFilterCount] = useState(0);
  const fromHome = Boolean(location?.state?.stage);
  const passdate = location?.state?.date;

  const selectedRowsMapRef = useRef(new Map());
  const [selectAllLoading, setSelectAllLoading] = useState(false);

  const upsertSelectedRows = (rows = []) => {
    rows.forEach((r) => {
      if (r && r.ConsignId != null) {
        selectedRowsMapRef.current.set(r.ConsignId, r);
      }
    });
  };

  const syncSelectedRows = (keys) => {
    setSelectedRows(
      keys.map((k) => selectedRowsMapRef.current.get(k)).filter(Boolean),
    );
  };

  const clearSelection = () => {
    selectedRowsMapRef.current.clear();
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  const [filterData, setFilterData] = useState(() => {
    let duration = "current_month";
    let daterange = [dayjs().startOf("month"), dayjs().endOf("month")];

    if (fromHome) {
      duration = "current_year";
      daterange = [dayjs().startOf("year"), dayjs().endOf("year")];
    } else if (passdate) {
      const parsedDate = dayjs(passdate.$d || passdate);
      duration = "custom_date";
      daterange = [parsedDate.startOf("day"), parsedDate.endOf("day")];
    }

    return {
      duration,
      daterange,
      event: location?.state?.stage || null,
    };
  });

  // keep filter form in sync
  useEffect(() => {
    if (fromHome) {
      filterform.setFieldValue("duration", "");
      filterform.setFieldValue("daterange", [null, null]);
      setFilterData((prev) => ({
        ...prev,
        duration: "",
        daterange: [null, null],
      }));
    } else if (passdate) {
      const parsedDate = dayjs(passdate.$d || passdate); // <-- fix here
      const dateRange = [parsedDate.startOf("day"), parsedDate.endOf("day")];

      filterform.setFieldValue("duration", "custom_date");
      filterform.setFieldValue("daterange", dateRange);
      setFilterData((prev) => ({
        ...prev,
        duration: "custom_date",
        daterange: dateRange,
      }));
    }
  }, [fromHome, passdate]);
  const [formType, setFormType] = useState("addEdit"); // 'addEdit' or 'bulkCreate'
  const [newtimeandvalue, setnewtimeandvalue] = useState(null);
  const [formData, setFormData] = useState({
    consignor:
      userInfo?.MCID === 46
        ? 32921
        : userInfo?.MCID === 55
          ? 1
          : userInfo?.MCID === 45
            ? 29727
            : "",
    transporter:
      userInfo?.MCID === 46
        ? 32922
        : userInfo?.MCID === 55
          ? 2
          : userInfo?.MCID === 45
            ? 29728
            : "",
    triptype: userInfo?.MCID === 46 || userInfo?.MCID === 55 ? 1 : "",
    consignee: [undefined],
    chargetype:
      userInfo?.MCID === 46 || userInfo?.MCID === 55
        ? 6
        : userInfo?.MCID === 45
          ? 1
          : "",
    priority:
      userInfo?.MCID === 46 || userInfo?.MCID === 55
        ? 1
        : userInfo?.MCID === 45
          ? 1
          : "",
    noofdeliverables: "",
    dimension: "",
    gross: "",
    switch: false,
    plocation: "",
    pdate: "",
    dlocation: "",
    ddate: "",
    pnotes: "",
    dnotes: "",
    remark: "",
    linkdossier: "",
    orderno: "",
    referenceno: "",
    containerno: "",
    zone: "",
    dlocationname: {},
    plocationname: {},
  });
  const dispatch = useDispatch();

  function generateKenyaTime(date = new Date()) {
    const options = {
      timeZone: "Africa/Nairobi",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour12: false,
    };
    const formatter = new Intl.DateTimeFormat("en-GB", options);

    const parts = formatter.formatToParts(date);

    const y = parts.find((p) => p.type === "year").value;
    const m = parts.find((p) => p.type === "month").value;
    const d = parts.find((p) => p.type === "day").value;
    const h = parts.find((p) => p.type === "hour").value;
    const min = parts.find((p) => p.type === "minute").value;
    const s = parts.find((p) => p.type === "second").value;

    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }

  let timeNow = generateKenyaTime();
  let afterOneHour = generateKenyaTime(new Date(Date.now() + 60 * 60 * 1000));
  const [resetCount, setResetCount] = useState(0);
  const handleCreateAnotherTrip = () => {
    setFormData((prev) => ({
      ...prev,
      pdate: "",
      ddate: "",
    }));
    setResetCount((prev) => prev + 1);
  };
  useEffect(() => {
    if (formType === "bulkCreate" || formType === "addEdit") {
      setFormData((prev) => ({
        ...prev,
        pdate: dayjs(timeNow),
        ddate: dayjs(afterOneHour),
      }));
    }
  }, [formType, resetCount]);

  useEffect(() => {
    setnewtimeandvalue(timeNow);
    generateKenyaTime();
  }, []);

  const tripType = [
    {
      label: "Local",
      value: 1,
    },
    { label: "Safari", value: 2 },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const fetchAllSelectableConsignments = async () => {
    const daterange = filterform?.getFieldValue("daterange");
    const dateFrom =
      daterange && dayjs(daterange[0]).isValid()
        ? dayjs(daterange[0]).format("YYYY-MM-DD")
        : "";
    const dateTo =
      daterange && dayjs(daterange[1]).isValid()
        ? dayjs(daterange[1]).format("YYYY-MM-DD")
        : "";

    const { data } = await CALL_API("POST", "consignments/getAll", {
      mcId: userInfo?.MCID,
      custName: filterData?.consignor || 0,
      recName: filterData?.consignee || 0,
      regNo: filterData?.vehicle || 0,
      status: activeTab === "label2" ? "1" : "2",
      priority: 1,
      code: filterData?.code || "",
      driverName: filterData?.driver || 0,
      dateFrom,
      dateTo,
      town: filterData?.town || 0,
      lastModify: filterData?.event,
      shipper: filterData?.transporter || 0,
      page: 1,
      pageSize: total || pageSize,
    });

    return Array.isArray(data?.data) ? data.data : [];
  };

  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const values = filterform.getFieldsValue();

  const [tripform] = Form.useForm();

  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);

  useEffect(() => {
    const duration = form.getFieldValue("duration");

    if (duration === "last_month") {
      form.setFieldValue("daterange", [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
      }));
    } else if (duration === "current_month") {
      form.setFieldValue("daterange", [
        dayjs().startOf("month"),
        dayjs().endOf("month"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs().startOf("month"), dayjs().endOf("month")],
      }));
    } else if (duration === "current_year") {
      form.setFieldValue("daterange", [
        dayjs().startOf("year"),
        dayjs().endOf("year"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs().startOf("year"), dayjs().endOf("year")],
      }));
    } else if (duration === "today") {
      form.setFieldValue("daterange", [dayjs(), dayjs()]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs(), dayjs()],
      }));
    } else if (duration === "---") {
      form.setFieldValue("daterange", [null, null]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [null, null],
      }));
    }
    // else {
    //   const today = dayjs();
    //   const sameDayLastMonth = today.subtract(1, 'month');
    //   form.setFieldValue("daterange", [ today, sameDayLastMonth]);
    //   setFilterData((PrevValue) => ({
    //     ...PrevValue,
    //     ["daterange"]: [
    //       today , sameDayLastMonth
    //     ],
    //   }));
    // }
  }, [form.getFieldValue("duration")]);

  const Duration1 = [
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];

  const tabItems = [
    {
      key: "label1",
      label: "Assigned",
    },
    {
      key: "label2",
      label: "Unassigned",
    },
  ];

  const [visibleExport, setVisibleExport] = useState(false);
  const [visibleImport, setVisibleImport] = useState(false);
  const [visibleSort, setVisibleSort] = useState(false);
  const [assignedConsignments, setAssignedConsignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [consignmentDetails, setConsignmentDetails] = useState({});
  const [locationModal, setLocationModal] = useState(false);
  const [initialLocation, setInitialLocation] = useState(null);
  const [isCreateTrip, setIsCreateTrip] = useState(false);
  const [isConformationModal, setIsConformationModal] = useState(false);
  const [newLoading, setNewLoading] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [selectedCustomColumns, setSelectedCustomColumns] = useState([]);
  const [customDataLoaded, setCustomDataLoaded] = useState(false);

  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);
  const [tripCustomFields, setTripCustomFields] = useState([]);
  const reftab = formType === "addEdit" ? "Consign" : "BulkCreate";
  const [allCustomDataConsign, setAllCustomDataConsign] = useState([]);
  const [allCustomDataBulkCreate, setAllCustomDataBulkCreate] = useState([]);
  const [customDataLoadedConsign, setCustomDataLoadedConsign] = useState(false);
  const [customDataLoadedBulkCreate, setCustomDataLoadedBulkCreate] =
    useState(false);

  const GetAllCustomeData = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=${reftab}`,
      );
      if (reftab === "Consign") {
        setAllCustomDataConsign(data);
        setCustomDataLoadedConsign(true);
      } else if (reftab === "BulkCreate") {
        setAllCustomDataBulkCreate(data);
        setCustomDataLoadedBulkCreate(true);
      }
      return data;
    } catch (error) {
      console.error("Error fetching custom data", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  filterform.getFieldValue("daterange");

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const fetchConsigneeList = async () => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: userInfo?.MCID,
      entType: 3,
    });
    dispatch(setConsigneeList(data));
  };

  const fetchConsignerList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: userInfo?.MCID,
      entType: 1,
    });
    dispatch(setConsignerList(data));
  };

  const getAssignedConsignments = async (overrides = {}) => {
    setLoading(true);
    const daterange = filterform?.getFieldValue("daterange");
    const dateFrom =
      daterange && dayjs(daterange[0]).isValid()
        ? dayjs(daterange[0]).format("YYYY-MM-DD")
        : "";
    const dateTo =
      daterange && dayjs(daterange[1]).isValid()
        ? dayjs(daterange[1]).format("YYYY-MM-DD")
        : "";

    // Always fetch fresh custom data if not explicitly passed in
    let effectiveConsignData = overrides?.consign;
    let effectiveBulkCreateData = overrides?.bulkCreate;

    if (
      effectiveConsignData === undefined ||
      effectiveBulkCreateData === undefined
    ) {
      const [freshConsign, freshBulkCreate] = await Promise.all([
        CALL_API(
          "GET",
          `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Consign`,
        )
          .then((r) => r.data)
          .catch(() => []),
        CALL_API(
          "GET",
          `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=BulkCreate`,
        )
          .then((r) => r.data)
          .catch(() => []),
      ]);
      effectiveConsignData = freshConsign;
      effectiveBulkCreateData = freshBulkCreate;
      setAllCustomDataConsign(freshConsign);
      setAllCustomDataBulkCreate(freshBulkCreate);
    }
    const { data, total } = await CALL_API("POST", "consignments/getAll", {
      mcId: userInfo?.MCID,
      custName: filterData?.consignor || 0,
      recName: filterData?.consignee || 0,
      regNo: filterData?.vehicle || 0,
      status: activeTab === "label2" ? "1" : "2",
      priority: 1,
      code: filterData?.code || "",
      driverName: filterData?.driver || 0,
      dateFrom: dateFrom,
      dateTo: dateTo,
      town: filterData?.town || 0,
      lastModify: filterData?.event,
      shipper: filterData?.transporter || 0,
      page: currentPage,
      pageSize: pageSize,
    });

    const mergedCustomDataSet = [
      ...(Array.isArray(effectiveConsignData) ? effectiveConsignData : []),
      ...(Array.isArray(effectiveBulkCreateData)
        ? effectiveBulkCreateData
        : []),
    ];

    const newData1 = data?.data?.map((entityItem) => {
      const enrichedItem = { ...entityItem };
      const matchedFields = mergedCustomDataSet.filter(
        (field) => field.REFID === entityItem.ConsignId,
      );
      matchedFields.forEach((field) => {
        enrichedItem[String(field.CFID)] = field.VALUE;
      });
      return enrichedItem;
    });

    setLoading(false);
    setAssignedConsignments(newData1 || []);
    setTotal(data?.total || 0);
    fetchConsigneeList();
    fetchConsignerList();
  };
  useEffect(() => {
    GetAllCustomeData("Consign");
    GetAllCustomeData("BulkCreate");
  }, []);
  // Ensure assigned consignments are fetched only after
  // custom data and custom column configuration are ready
  useEffect(() => {
    if (
      customDataLoadedBulkCreate &&
      customDataLoadedConsign &&
      Array.isArray(customFields) &&
      customFields.length > 0 &&
      Array.isArray(selectedCustomColumns) &&
      selectedCustomColumns.length > 0
    ) {
      getAssignedConsignments();
    }
  }, [
    formType,
    customDataLoadedBulkCreate,
    customDataLoadedConsign,
    customFields,
    selectedCustomColumns,
  ]);
  const TRIP_REFTAB = "Trip"; // or whatever your backend expects
  //navigate function on home page
  useEffect(() => {
    if (location.state?.tab === "CreateSingleConsignmentAI+") {
      setDrawerOpen(true);
      setFormType("addEdit"); // this will trigger single consignment form
    }
  }, [location.state]);

  const loadTripCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: TRIP_REFTAB,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setTripCustomFields(data);
    } catch (error) {
      setTripCustomFields([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (isCreateTrip) {
      loadTripCustomFields();
    }
  }, [isCreateTrip]);
  const [CreateTripCustomeData, setCreateTripCustomeData] = useState([]);

  const CustomeTripDataCreate = async (TRIPID, values) => {
    try {
      const customDataList = tripCustomFields
        .map((field) => {
          if (!field?.FIELDNAME) return null;

          const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
          const value = values?.[fieldName];

          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: TRIPID,
              Value: value,
            };
          }

          return null;
        })
        .filter(Boolean);

      if (customDataList.length === 0) {
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateTripCustomeData(data);
    } catch (error) {
      setCreateTripCustomeData([]);
    }
  };

  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const daterange = filterform?.getFieldValue("daterange");
      const dateFrom =
        daterange && dayjs(daterange[0]).isValid()
          ? dayjs(daterange[0]).format("YYYY-MM-DD")
          : "";
      const dateTo =
        daterange && dayjs(daterange[1]).isValid()
          ? dayjs(daterange[1]).format("YYYY-MM-DD")
          : "";
      const { data } = await CALL_API("POST", "consignments/getAll", {
        mcId: userInfo?.MCID,
        custName: filterData?.consignor || 0,
        recName: filterData?.consignee || 0,
        regNo: filterData?.vehicle || 0,
        status: activeTab === "label2" ? "1" : "2",
        priority: filterData?.priority || 1,
        code: filterData?.code || "",
        driverName: filterData?.driver || 0,
        dateFrom: dateFrom,
        dateTo: dateTo,
        town: filterData?.town || 0,
        shipper: filterData?.transporter || 0,
        page: 1,
        pageSize: total,
      });

      const consignmentData = data?.data || [];

      // Export should include custom fields/values from BOTH reftabs (Consign + BulkCreate)
      const [consignDefsResp, bulkDefsResp] = await Promise.all([
        CALL_API("POST", `mastertable/GetByReftab`, {
          ReftableId: "Consign",
          RefId: 0,
          Active: 1,
          McId: userInfo?.MCID,
        }),
        CALL_API("POST", `mastertable/GetByReftab`, {
          ReftableId: "BulkCreate",
          RefId: 0,
          Active: 1,
          McId: userInfo?.MCID,
        }),
      ]);

      const mergedFieldDefsMap = new Map();
      const mergedDefs = [
        ...(Array.isArray(consignDefsResp?.data) ? consignDefsResp.data : []),
        ...(Array.isArray(bulkDefsResp?.data) ? bulkDefsResp.data : []),
      ];
      for (const f of mergedDefs) {
        const key = String(f?.CFID ?? "");
        if (!key) continue;
        if (!mergedFieldDefsMap.has(key)) mergedFieldDefsMap.set(key, f);
      }
      const exportFieldDefs = Array.from(mergedFieldDefsMap.values());

      const customFieldMap = {};
      exportFieldDefs.forEach((cf) => {
        if (cf?.CFID) {
          customFieldMap[String(cf.CFID)] = cf.FIELDNAME || cf.FIELDCODE;
        }
      });

      const mergedCustomValues = [
        ...(Array.isArray(allCustomDataConsign) ? allCustomDataConsign : []),
        ...(Array.isArray(allCustomDataBulkCreate)
          ? allCustomDataBulkCreate
          : []),
      ];

      const enrichedData = consignmentData.map((item) => {
        const matchedFields =
          mergedCustomValues.filter(
            (f) => Number(f?.REFID) === Number(item?.ConsignId),
          ) || [];

        const customFieldValues = {};

        // Ensure every custom field exists
        exportFieldDefs.forEach((cf) => {
          const cfidKey = String(cf?.CFID ?? "");
          const fieldName = customFieldMap[cfidKey] || `Custom_${cfidKey}`;

          // If the same CFID exists twice (both reftabs), prefer non-empty VALUE
          const candidates = matchedFields.filter(
            (f) => String(f?.CFID ?? "") === cfidKey,
          );
          let picked = candidates[0];
          for (const c of candidates) {
            const v = c?.VALUE;
            const hasVal =
              v !== undefined && v !== null && String(v).trim() !== "";
            if (hasVal) {
              picked = c;
              break;
            }
          }

          customFieldValues[fieldName] = picked?.VALUE ?? "-";
        });

        // Merge base and custom data for export
        return {
          Date: item.cron
            ? dayjs(item.cron).format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "Consign Code": item.Code || "-",
          Priority: item.Priority === 1 ? "High" : "Normal",
          "Vehicle/Driver": `${item.RegNo || "-"} / ${item.DriverName || "-"}`,
          Event:
            EventType.find((ev) => ev.value === item.LastModify)?.name ||
            (activeTab === "label2" ? "Unassigned" : "Assigned"),
          Consignor: item.CustName || "-",
          Consignee: item.RecName || "-",
          Transporter: item.SupName || "-",
          Location: locationCache[`${item.EndLat},${item.EndLng}`] || "-",
          ...customFieldValues,
        };
      });

      //  Export if data exists
      if (enrichedData.length > 0) {
        setCSVList(enrichedData);
        setTimeout(() => csvLinkEl.current.link.click(), 500);
      } else {
        message.error("No data available to download.");
      }

      setCSVLoader(false);
    } catch (error) {
      setCSVLoader(false);
      console.error("[prepareCSV] error -->", error);
    }
  };

  const loadCustomFields = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: reftab,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  //single customdata create function
  const [singleCreateCustomeData, setsingleCreateCustomeData] = useState([]);

  const SingleCustomeDataCreate = async (reftab, ConsignId, values) => {
    try {
      const customDataList = customFields
        ?.map((field) => {
          const fieldKey = field.CFID;
          const value = values?.[fieldKey];

          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: ConsignId,
              Value: value,
            };
          }
          return null;
        })
        .filter(Boolean);
      if (customDataList.length === 0) {
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setsingleCreateCustomeData(data);
    } catch (error) {
      console.error("Custom field creation error:", error);
      setsingleCreateCustomeData([]);
      message.error("Failed to create custom fields.");
    }
  };
  const [CreateCustomeData, setCreateCustomeData] = useState([]);

  const CustomeDataCreate = async (reftab, ConsignId, customDataPayload) => {
    const customDataList = [
      {
        CfId: customDataPayload.CFID,
        RefId: customDataPayload.RefId,
        Value: customDataPayload.Value,
      },
    ];
    try {
      if (!customDataList.length) {
        return;
      }
      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });
      setCreateCustomeData(data);
      const latest = await GetAllCustomeData(reftab);
      await getAssignedConsignments(
        reftab === "Consign"
          ? { consign: latest }
          : reftab === "BulkCreate"
            ? { bulkCreate: latest }
            : {},
      );
      return {
        success: true,
        data: data,
      };
    } catch (error) {
      setCreateCustomeData([]);
      message.error("Failed to create custom fields.");
      return { success: false };
    }
  };

  const CustomeDataUpdate = async (reftab, ConsignId, values) => {
    setLoading(true);
    try {
      for (const field of customFields) {
        const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
        let value = values?.[fieldName];
        if (value === undefined || value === null || value === "") {
          value = values?.[String(field.CFID)];
        }
        const existing = AllCustomeData?.find(
          (item) =>
            Number(item.REFID) === Number(ConsignId) &&
            Number(item.CFID) === Number(field.CFID),
        );
        if (value !== undefined && value !== "") {
          if (existing) {
            // UPDATE
            const payload = {
              CfId: Number(field.CFID),
              RefId: ConsignId,
              Value: value,
              DataId: existing.DATAID,
            };
            await CALL_API("PATCH", "mastertable/updateCustomData", payload);
          } else {
            // INSERT
            await SingleCustomeDataCreate(reftab, ConsignId, values);
          }
        }
      }
      const latest = await GetAllCustomeData(reftab);
      await getAssignedConsignments(
        reftab === "Consign"
          ? { consign: latest }
          : reftab === "BulkCreate"
            ? { bulkCreate: latest }
            : {},
      );
    } catch (error) {
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  const calculateCarbonFootPrint = async () => {
    const { data } = await CALL_API("GET", "consign/calculateCarbonFootPrint");
  };
  useEffect(() => {
    calculateCarbonFootPrint();
  }, []);

  // AllCustomeData is consumed inside getAssignedConsignments; it will be
  // re-fetched via the above and other effects when needed.

  const CustomeDataDelete = async (reftab, ConsignId) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: ConsignId,
          RefTab: reftab,
          McId: userInfo?.MCID,
        },
      );
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadCustomFields(reftab);
    GetAllCustomeData(reftab);
  }, [reftab]);
  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [configId, setconfigId] = useState(null); // To store the ID of the consignment to delete

  const handleclickconfig = (id) => {
    setIsconfigModalVisible(true);
  };

  const handleUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file); // 'file' is the key your backend will expect
    try {
      setLoading(true);
      const response = await axios.post(
        "https://7gyutppcwl.execute-api.us-east-1.amazonaws.com/Prod/consignment/import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: window?.localStorage?.getItem("token") || "",
          },
        },
      );

      // const response = await CALL_API("POST", `consignments/import`, file, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // });

      if (response.status === 200) {
        message.success("CSV imported successfully!");
        getAssignedConsignments();
        setLoading(false);
      } else {
        message.error("Failed to import CSV.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Something went wrong during upload.");
    }

    return false; // Prevent default upload behavior
  };

  const handleTripCreate = async (values) => {
    setLoading(true);
    try {
      const { data, ResponseCode } = await CALL_API("POST", "trip/createTrip", {
        McId: userInfo?.MCID,
        VehId: values.vehicle,
        Remarks: values.remark,
        userId: userInfo?.UID,
        TripType: values.tripType,
        ConsignmentIds: selectedRowKeys,
      });
      if (ResponseCode === 400) {
        message.warning(data);
        setLoading(false);
        return;
      }
      const TripId = data?.TripId || data?.TRIPID || data?.result?.TRIPID;

      // Save custom fields for the trip
      if (TripId) {
        await CustomeTripDataCreate(TripId, values);
      } else {
        console.error("TripId not found in API response:", data);
      }
      tripform?.resetFields();
      setIsCreateTrip(false);
      clearSelection();
      await getAssignedConsignments();
      message.success("Trip created successfully!");
      setLoading(false);
    } catch (error) {
      console.error("[handleTripCreate] error -->", error);
      message.error("Failed to create trip. Please try again.");
      setLoading(false);
    }
  };
  const handleTooltipVisibleChangeExport = (visible) => {
    setVisibleExport(visible);
    hideTooltipArrow();
  };

  const handleTooltipVisibleChangeImport = (visible) => {
    setVisibleImport(visible);
    hideTooltipArrow();
  };

  const handleTooltipVisibleChangeSort = (visible) => {
    setVisibleSort(visible);
    hideTooltipArrow();
  };

  const hideTooltipArrow = () => {
    setTimeout(() => {
      const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
      tooltipArrows.forEach((arrow) => {
        arrow.style.display = "none";
      });
    }, 0);
  };

  const [sortField, setSortField] = useState(null);

  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "label1",
  ); // Default to "Assigned"

  const [consignee, setConsignee] = useState(null);
  const [hoveredrow, setHoveredrow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [copyId, setCopyId] = useState(null);

  const handleChange = (e, fieldName, index, isnested = false) => {
    const value = e?.target?.value;

    setFormData((prev) => {
      if (isnested) {
        const prevCustom = prev.customData || {};
        const existing = Array.isArray(prevCustom[fieldName])
          ? [...prevCustom[fieldName]]
          : [];
        existing[index] = value;

        return {
          ...prev,
          customData: {
            ...prevCustom,
            [fieldName]: existing,
          },
        };
      }

      const { name } = e.target;
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const csvLinkEl = useRef();

  const [isEditing, setIsEditing] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [assignVehicleId, setAssignVehicleId] = useState(null);
  const [assignDriverId, setAssignDriverId] = useState([]);
  const [getCodebyvehicle, setCodebyVehicle] = useState([]);
  const [getcode, setGetcode] = useState(null);

  const [codeList, setCodeList] = useState([]);

  const [selectedTripCode, setSelectedTripCode] = useState(null);
  const [assignTripId, setAssignTripId] = useState(null);

  const showDrawer = () => {
    setIsEditing(false);
    setFormData({
      consignor: "",
      transporter: "",
      consignee: "",
      chargetype: "",
      priority: "",
      noofdeliverables: "",
      dimension: "",
      gross: "",
      switch: "",
      plocation: "",
      pdate: "",
      dlocation: "",
      ddate: "",
      pnotes: "",
      dnotes: "",
      remark: "",
      linkdossier: "",
      orderno: "",
      referenceno: "",
      containerno: "",
      zone: "",
    });
    setDrawerOpen(true);
  };

  const [pickupDropoffLocations, setPickupDropoffLocations] = useState([]);
  const getpickupDropoff = async (consignorId) => {
    try {
      const { data } = await CALL_API(
        "GET",
        `consign/getpickupDropofflocation?ENTID=${consignorId}&MCID=${userInfo?.MCID}`,
        {},
      );

      const locations = Array.isArray(data?.data) ? data.data : [];
      // setPickupDropoffLocations(data || []);
      setFormData((prev) => ({
        ...prev,
        plocation: data?.[0]?.ADDRESS,
        plocationname: {
          latitude: data?.[0]?.LATITUDE || 0,
          longitude: data?.[0]?.LONGITUDE || 0,
          place_name: data?.[0]?.ADDRESS || 0,
        },
      }));
      AddEditFormm?.setFieldValue("plocation", locations[0]?.ADDRESS);
      BulkCreateForm?.setFieldValue("plocation", locations[0]?.ADDRESS);
    } catch (error) {
      console.error("getpickupDropoff error -->", error);
    }
  };

  const getpickupDrop = async (consigneeId) => {
    try {
      const { data } = await CALL_API(
        "GET",
        `consign/getpickupDropofflocation?ENTID=${consigneeId}&MCID=${userInfo?.MCID}`,
        {},
      );
      // setPickupDropoffLocations(data || [])
      setFormData((prev) => ({
        ...prev,
        dlocation: data?.[0]?.ADDRESS,
        dlocationname: {
          latitude: data?.[0]?.LATITUDE || 0,
          longitude: data?.[0]?.LONGITUDE || 0,
          place_name: data?.[0]?.ADDRESS || 0,
        },
      }));
    } catch (error) {
      console.error("getpickupDropoff error -->", error);
    }
  };

  useEffect(() => {
    getpickupDropoff(formData?.consignor);
  }, [formData?.consignor]);

  useEffect(() => {
    getpickupDrop(formData?.consignee);
  }, [formData?.consignee]);

  const onTripCodeSelect = (code) => {
    setSelectedTripCode(code);
    const selected = codeList?.find((item) => item?.Code === code);
    if (selected) {
      setAssignTripId(selected?.TripId);
    }
  };
  const getCodeByVehicleId = async (vehicleId) => {
    try {
      const { data } = await CALL_API(
        "GET",
        `consign/getCodebyVehicle?vehicleId=${assignVehicleId}`,
        {},
      );
      setCodeList(data || []);
    } catch (error) {
      console.error("getCodeByVehicleId error -->", error);
    }
  };

  const driveridone = driverWithVehicle?.find(
    (vehicle) => vehicle?.VEHID === assignVehicleId,
  );

  useEffect(() => {
    getCodeByVehicleId();
  }, [assignVehicleId]);

  const verifyTrip = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `consignment/verify_trip`, {
      TripId: assignTripId,
      ConsignmentIds: selectedRowKeys,
    });
    setLoading(false);
  };

  const AssignedVehicle = async () => {
    if (!assignTripId) {
      message.warning("Please select a trip code.");
      return;
    }

    setLoading(true);
    try {
      // Call verifyTrip first
      await verifyTrip();

      // Proceed with assigning the vehicle only after verifyTrip succeeds
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `consignment/assign_trip`,
        {
          TripId: assignTripId,
          ConsignmentIds: selectedRowKeys,
          UserId: userInfo?.UID,
        },
      );

      // Reset states and fetch updated data
      setAssignModal(false);
      setSelectedRowKeys([]);
      getAssignedConsignments();
      message.success("Trip verified and assigned successfully.");
    } catch (error) {
      console.error("Error in verifyTrip or AssignedVehicle:", error);
      message.error("Failed to verify and assign the trip. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // const getCodeByVehicle = async (vehicleId) => {
  //   try {
  //     const { data } = await CALL_API(
  //       "GET",
  //       `consign/getCodebyVehicle?vehicleId=${vehicleId}`,
  //       {}
  //     );
  //     setCodeList(data || []);
  //   } catch (error) {
  //     console.error("getCodeByVehicleId error -->", error);
  //   }
  // };

  // useEffect(() => {
  //   getCodebyVehicle();
  // }, []);

  const editUser = (record) => {
    setIsEditing(true);
    setFormData(record);
    setDrawerOpen(true);
  };

  const handleCancel = () => {
    setIsEdit(false);
    setConsignee(false);
    setDrawerOpen(false);
    setFormData({
      consignor:
        userInfo?.MCID === 46
          ? 32921
          : userInfo?.MCID === 55
            ? 1
            : userInfo?.MCID === 45
              ? 29727
              : "",
      transporter:
        userInfo?.MCID === 46
          ? 32922
          : userInfo?.MCID === 55
            ? 2
            : userInfo?.MCID === 45
              ? 29728
              : "",
      triptype: userInfo?.MCID === 46 || userInfo?.MCID === 55 ? 1 : "",
      consignee: [undefined],
      chargetype:
        userInfo?.MCID === 46 || userInfo?.MCID === 55
          ? 6
          : userInfo?.MCID === 45
            ? 1
            : "",
      priority:
        userInfo?.MCID === 46 || userInfo?.MCID === 55 || userInfo?.MCID === 45
          ? 1
          : "",
      noofdeliverables: "",
      dimension: "",
      gross: "",
      switch: "",
      plocation: "",
      pdate: "",
      dlocation: "",
      ddate: "",
      pnotes: "",
      dnotes: "",
      remark: "",
      linkdossier: "",
      orderno: "",
      referenceno: "",
      containerno: "",
      zone: "",
      dropoffnotes: "",
    });
    form.resetFields();
  };

  const handleClickme = (record) => {
    setHoveredrow(record.key);
  };
  const handleClickeditdrawer = (event, record) => {
    setDrawerOpen(true);
    event.stopPropagation();
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setPageSize(10);
    setCurrentPage(1);
    setSelectedKeys([]);
    clearSelection();
  };

  const [selectedKeys, setSelectedKeys] = useState([]);

  const handleCheckboxChange = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const [selectedRows, setSelectedRows] = useState([]);

  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRows(selectedRowKeys);
  //   },
  // };

  const [showModal, SetshowModal] = useState(false);

  const [resolveModal, setResolveModal] = useState(false);
  const [sortFields, setSortFields] = useState([]);

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isBulkDeleteModalVisible, setIsBulkDeleteModalVisible] =
    useState(false);
  const [bulkDeleteId, setBulkDeleteId] = useState(null);
  const handleresolveopen = () => {
    setResolveModal(true);
  };

  const handleresolveclose = () => {
    setResolveModal(false);
  };
  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const closeEditModal = () => {
    setResolveModal(false);
  };
const editModuleupdate = () => {
  setFilterData({
    code: "",
    consignee: "",
    consignor: "",
    driver: "",
    duration: "current_month",
    event: "",
    town: "",
    transporter: "",
    vehicle: "",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  filterform.setFieldsValue({
    code: "",
    consignee: "",
    consignor: "",
    driver: "",
    duration: "current_month",
    event: "",
    town: "",
    transporter: "",
    vehicle: "",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
};

  const handleLocationSelect = (location) => {
    if (!location || !location.center) return;

    const [longitude, latitude] = location.center;

    setFormData((prev) => ({
      ...prev,
      [selectedItem]: location.place_name,
      [`${selectedItem}name`]: {
        place_name: location.place_name,
        latitude,
        longitude,
      },
    }));

    setLocationModal(false);
  };
  const [expandedRows, setExpandedRows] = useState({});

  const toggleViewMore = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const selectedColumns = [
    {
      title: "Date",
      dataIndex: "cron",
      key: "cron",
      render: (text) => {
        return text ? moment(text).format("Do MMM YYYY; hh:mm A") : "-";
      },
    },
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
    },
    {
      title: "Pickup Location",
      dataIndex: "StartLocation",
      key: "StartLocation",
    },
    {
      title: "Dropoff Location",
      dataIndex: "EndLocation",
      key: "EndLocation",
    },
    {
      title: "Pickup Date Time",
      dataIndex: "PickUpDateTime",
      key: "PickUpDateTime",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Dropoff Date Time",
      dataIndex: "DropOffDateTime",
      key: "DropOffDateTime",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Volume",
      dataIndex: "location",
      key: "location",
    },
  ];

  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };
  const [locationCache, setLocationCache] = useState({});
  const dynamicCustomColumns = useMemo(() => {
    if (!Array.isArray(customFields) || customFields.length === 0) return [];
    return customFields
      .filter((field) => selectedCustomColumns.includes(String(field.CFID)))
      .map((field) => ({
        title: field.FIELDNAME,
        dataIndex: String(field.CFID),
        key: String(field.CFID),
        sorter: false,
        render: (text) => text || "-",
      }));
  }, [customFields, selectedCustomColumns]);
  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
        label: field.FIELDNAME,
        value: String(field.CFID),
        disabled: false,
      }))
    : [];
  const baseColumns = [
    {
      title: "Date",
      dataIndex: "cron",
      key: "cron",
      sorter: sortFields?.includes("Date")
        ? (a, b) => new Date(b.cron) - new Date(a.cron)
        : false,
      render: (value) => {
        if (!value) return "-";
        return new Date(value).toLocaleDateString("en-GB");
      },
    },
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
      sorter: sortFields?.includes("Order No")
        ? (a, b) => Number(b.Code) - Number(a.Code)
        : false,
      defaultSortOrder: sortFields?.includes("Order No")
        ? "descend"
        : undefined,
      render: (code, record) => {
        return (
          <>
            <p>{code}</p>
            {record?.Priority === 1 ? (
              <i>Normal</i>
            ) : (
              <div className="inactive-status">
                <span className="red-dot"></span>
                <span>High</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Vehicle / Driver",
      dataIndex: "DriverName",
      key: "DriverName",
      render: (text, record) => (
        <div>
          <p>{record?.RegNo || ""}</p>
          <p style={{ fontStyle: "italic", color: "#5F6D8C" }}>{text || ""}</p>
        </div>
      ),
    },
    {
      title: "Event",
      dataIndex: "LastModify",
      key: "LastModify",
      render: (text) => {
        const event = EventType.find((item) => item.value === text);
        return event
          ? event.name
          : activeTab === "label2"
            ? "Unassigned"
            : "Assigned";
      },
    },
    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      sorter: sortFields?.includes("consignee")
        ? (a, b) => a.CustName.localeCompare(b.CustName)
        : false,
      ellipsis: false, // Disable truncation to allow wrapping
      render: (text) => <div className="text-wrap">{text}</div>, // Wrap text
    },
    {
      title: "Consignee",
      dataIndex: "RecName",
      key: "RecName",
      sorter: sortFields.includes("consignorrr")
        ? (a, b) => a.RecName.localeCompare(b.RecName)
        : false,
      ellipsis: false, // Disable truncation to allow wrapping
      render: (text) => <div className="text-wrap">{text}</div>, // Wrap text
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      sorter: sortFields.includes("Location")
        ? (a, b) => a.location.localeCompare(b.location)
        : false,
      render: (_, record) => {
        const key = record.key;
        const isExpanded = expandedRows[key];

        return (
          <LocationCell
            startLat={record.StartLat}
            startLng={record.StartLng}
            endLat={record.EndLat}
            endLng={record.EndLng}
            locationCache={locationCache}
            setLocationCache={setLocationCache}
            renderText={(locationText) => {
              const truncated =
                locationText?.length > 50 && !isExpanded
                  ? `${locationText.substring(0, 50)}...`
                  : locationText;

              return (
                <div>
                  <p
                    style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    {truncated}
                  </p>

                  {locationText?.length > 50 && (
                    <span
                      style={{ color: "#2C963D", cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleViewMore(key);
                      }}
                    >
                      {isExpanded ? "View Less" : "View More"}
                    </span>
                  )}
                </div>
              );
            }}
          />
        );
      },
    },
  ];
  const combinedColumns = useMemo(() => {
    const staticCols = [...baseColumns];

    // Only show custom fields that are selected
    const dynamicCols = customFields
      .filter((field) => selectedCustomColumns.includes(String(field.CFID)))
      .map((field) => ({
        title: field.FIELDNAME,
        dataIndex: String(field.CFID),
        key: String(field.CFID),
        sorter: false,
        render: (_, record) => record?.[String(field.CFID)] ?? "-",
      }));

    return [...staticCols, ...dynamicCols];
  }, [baseColumns, customFields, selectedCustomColumns]);
  const transporterColumn = {
    title: "Transporter",
    dataIndex: "SupName",
    key: "SupName",
    sorter: (a, b) =>
      sortFields.includes("Transporterrr")
        ? a.SupName.localeCompare(b.SupName)
        : false,
    ellipsis: false, // Disable truncation to allow wrapping
    render: (text) => {
      // Check if `text` is an array and remove duplicates
      const uniqueText = Array.isArray(text) ? [...new Set(text)] : [text];
      return (
        <div className="text-wrap">
          {uniqueText.join(", ")} {/* Join unique values with a comma */}
        </div>
      );
    },
  };

  const actionsColumn = {
    title: "Actions",
    key: "actions",
    width: "15%",
    render: (_, record) => {
      return (
        <div
          className={
            hoveredrow === record.key ? "d-flex gap-3 opacity-100" : "opacity-0"
          }
        >
          <Tooltip title={!copyAllowed ? "No permission" : ""}>
            <CopyIcon
              style={{ cursor: copyAllowed ? "pointer" : "not-allowed" }}
              onClick={(e) => {
                if (!copyAllowed) return;
                e.stopPropagation();
                setIsConformationModal(true);
                setCopyId(record?.ConsignId);
              }}
            />
          </Tooltip>
          <Tooltip title={!updateAllowed ? "No permission" : ""}>
            <EditIcon
              style={{
                cursor: updateAllowed ? "pointer" : "not-allowed",
                marginLeft: "10px",
              }}
              onClick={(e) => {
                if (!updateAllowed) return;
                e.stopPropagation();
                const newFormData = {
                  ...record,
                  chargetype: record?.ChargeType,
                  consignor: consignerList?.find(
                    (item) => item?.Name === record?.CustName,
                  )?.ID,
                  ddate: dayjs(record?.DropOffDateTime),
                  dropoffnotes: record?.DropOffNote,
                  dlocation: record?.EndLocation,
                  gross: record?.GrossVolume,
                  GrossWeight: record?.GrossWeight,
                  pdate: dayjs(record?.PickUpDateTime),
                  pickupnotes: record?.PickUpNote,
                  priority: record?.Priority,
                  transporter: transporterList?.find(
                    (item) => item?.Name === record?.SupName,
                  )?.ID,
                  remark: record?.Remarks,
                  consignee: consigneeList?.find(
                    (item) => item?.Name === record?.RecName,
                  )?.ID,
                  plocation: record?.StartLocation,
                  TripId: record?.TripId,
                  CrBy: record?.CrBy,
                  ConsignId: record?.ConsignId,
                  EndLat: record?.EndLat,
                  EndLng: record?.EndLng,
                  switch: false,
                  StartLat: record?.StartLat,
                  StartLng: record?.StartLng,
                };

                setFormData(newFormData);
                setIsEdit(true);
                setDrawerOpen(true);

                // Always fetch pickup location for the selected consignor
                getpickupDropoff(newFormData.consignor);
                getpickupDrop(newFormData?.consignee);
              }}
            />
          </Tooltip>
          <Tooltip title={!deleteAllowed ? "No permission" : ""}>
            <DeleteIcon
              style={{
                cursor: deleteAllowed ? "pointer" : "not-allowed",
                marginLeft: "10px",
              }}
              onClick={(e) => {
                if (!deleteAllowed) return;
                e.stopPropagation();
                setDeleteId(record?.ConsignId); // Set the ID of the consignment to delete
                setIsDeleteModalVisible(true); // Show the delete confirmation modal
              }}
            />
          </Tooltip>
        </div>
      );
    },
  };

  useEffect(() => {
    if (consignmentRecord && Object.keys(consignmentRecord).length) {
      setConsignmentDetails(consignmentRecord);
      setConsignee(true);
    }
  }, [consignmentRecord]);

  useEffect(() => {
    if (filterform.getFieldValue("duration") === "last_month") {
      filterform.setFieldValue("daterange", [
        moment().subtract(1, "months").startOf("month"),
        moment().subtract(1, "months").endOf("month"),
      ]);
    } else if (filterform.getFieldValue("duration") === "current_month") {
      filterform.setFieldValue("daterange", [
        moment().startOf("month"),
        moment().endOf("month"),
      ]);
    } else if (filterform.getFieldValue("duration") === "current_year") {
      filterform.setFieldValue("daterange", [
        moment().startOf("year"),
        moment().endOf("year"),
      ]);
    } else if (filterform.getFieldValue("duration") === "today") {
      filterform.setFieldValue("daterange", [moment(), moment()]);
    } else if (filterform.getFieldValue("duration") === "---") {
      filterform.setFieldValue("daterange", [null, null]);
    }
  }, [filterform.getFieldValue("duration")]);

  useEffect(() => {
    // Set default filter only if not navigating from Home
    if (!location.state?.stage && !location.state?.shipmentTypes) {
      filterform.setFieldsValue({
        duration: "current_month",
        daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
      });
      setFilterData({
        duration: "current_month",
        daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
      });
    }
  }, []);

  const additionalColumnForUnassigned = {
    title: <Checkbox />,
    dataIndex: "checkbox",
    key: "checkbox",
    width: "5%",
    render: (_, record) => (
      <Checkbox
        checked={selectedKeys.includes(record.key)}
        onChange={() => handleCheckboxChange(record.key)}
      />
    ),
  };

  const columnsForAssigned = [
    ...combinedColumns,
    transporterColumn,
    actionsColumn,
  ];
  const columnsForUnassigned = [
    // additionalColumnForUnassigned,
    ...combinedColumns.filter(
      (col) =>
        col.key !== "transporter" &&
        col.key !== "actions" &&
        col.key !== "DriverName" &&
        col.key !== "event",
    ),
    actionsColumn,
  ];

  const pageRowKeys = useMemo(
  () =>
    (assignedConsignments || [])
      .map((r) => r.ConsignId)
      .filter((k) => k != null),
  [assignedConsignments],
    );

    // Reflect selection state against the FULL dataset (all pages), not just this page
    const isAllSelected = total > 0 && selectedRowKeys.length >= total;
    const isPartiallySelected =
      selectedRowKeys.length > 0 && selectedRowKeys.length < total;

    const handleHeaderSelectAllChange = async (checked) => {
      if (!checked) {
        clearSelection();
        return;
      }
      setSelectAllLoading(true);
      try {
        const allRows = await fetchAllSelectableConsignments();
        upsertSelectedRows(allRows);
        const allKeys = allRows.map((r) => r.ConsignId).filter((k) => k != null);
        setSelectedRowKeys(allKeys);
        syncSelectedRows(allKeys);
      } catch (error) {
        console.error("[handleHeaderSelectAllChange] error -->", error);
        message.error("Failed to select all consignments.");
      } finally {
        setSelectAllLoading(false);
      }
    };

    const rowSelection = {
      selectedRowKeys,
      preserveSelectedRowKeys: true,
      columnTitle: (
        <Checkbox
          checked={isAllSelected}
          indeterminate={isPartiallySelected}
          onChange={(e) => handleHeaderSelectAllChange(e.target.checked)}
        />
      ),
      onChange: (newSelectedRowKeys, newSelectedRows) => {
        upsertSelectedRows(newSelectedRows);
        setSelectedRowKeys(newSelectedRowKeys);
        syncSelectedRows(newSelectedRowKeys);
      },
    };

  const handleFilterChange = (e) => {
    const { value, name } = e.target;
    setCurrentPage(1);
    setFilterData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };

  const handleFilterSelectChange = (field, value) => {
    setCurrentPage(1);
    setFilterData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  const currentColumns =
    activeTab === "label1" ? columnsForAssigned : columnsForUnassigned;

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const handleCreateClick = () => {
    handleCreateAnotherTrip();
    setFormType("addEdit");
    // prefer formData.consignor, fall back to user defaults
    const consignorId =
      formData?.consignor ||
      (userInfo?.MCID === 46
        ? 32921
        : userInfo?.MCID === 55
          ? 1
          : userInfo?.MCID);

    // prefetch pickup location for the consignor so the drawer shows data immediately
    if (consignorId) getpickupDropoff(consignorId);
    setDrawerOpen(true);
  };

  const handleBulkCreateClick = () => {
    handleCreateAnotherTrip();
    setFormType("bulkCreate");
    const consignorId =
      formData?.consignor ||
      (userInfo?.MCID === 46
        ? 32921
        : userInfo?.MCID === 55
          ? 1
          : userInfo?.MCID);

    if (consignorId) getpickupDropoff(consignorId);

    setDrawerOpen(true);
  };

  const mapCustomFields = (fields) =>
    fields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;
      if (field.FIELDTYPE === 10 || field.DATATYPE === "BOOLEAN") {
        type = "checkbox";
      }
      // ... (options parsing logic remains the same)
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value);
      }
      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        // ... (rest of the field properties)
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name] || "",
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });

  //Bulk create customfield functions
  const consigneeCustomFields = customFields?.filter(
    (f) => f.REFTABLE === "BulkCreate",
  );
  const mappedConsigneeCustomFields = mapCustomFields(consigneeCustomFields);
  const generalCustomFields = customFields?.filter(
    (f) => f.REFTABLE === "BulkCreate",
  );
  const mappedGeneralCustomFields = mapCustomFields(generalCustomFields);
  const customFieldRows = chunkArray(mappedGeneralCustomFields || [], 1);
  const AddEditFormm = useMemo(() => {
    const staticFields = [
      [
        {
          id: 1,
          label: "Consignor",
          type: "selectwithvalue",
          name: "consignor",
          placeholder: "",
          options: consignerList?.map((item) => ({
            label: item.Name,
            value: item.ID,
          })),
          disabled: userInfo?.MCID === 45,
          options:
            userInfo?.MCID === 46
              ? consignerList
                  ?.filter((item) => item.ID === 32921)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 45
                ? consignerList
                    ?.filter((item) => item.ID === 29727)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          maxLength: 50,
          style: "",
          validationRules: [
            { required: true, message: "Consignor is required" },
          ],
        },
        {
          id: 2,
          label: "Transporter",
          type: "selectwithvalue",
          name: "transporter",
          placeholder: "Cargo",
          disabled: userInfo?.MCID === 45,
          options:
            userInfo?.MCID === 46
              ? transporterList
                  ?.filter((item) => item.ID === 32922)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 45
                ? transporterList
                    ?.filter((item) => item.ID === 29728)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          style: "",
          validationRules: [
            { required: true, message: "Transporter is required" },
          ],
        },
        {
          id: 2,
          label: "Trip Type",
          type: "selectwithvalue",
          name: "triptype",
          placeholder: "Local",
          onChange: handleChange,
          maxLength: 50,
          options:
            userInfo?.MCID === 46
              ? TripTypeEnum?.filter((item) => item.value === 1).map(
                  (item) => ({
                    label: item.name,
                    value: item.value,
                  }),
                )
              : TripTypeEnum?.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
          validationRules: [
            { required: true, message: "Trip type is required" },
          ],
        },
        {
          id: 4,
          label: "Charge Type",
          type: "selectwithvalue",
          name: "chargetype",
          disabled: userInfo?.MCID === 45,
          options:
            userInfo?.MCID === 46
              ? chargetype
                  ?.filter((item) => item.value === 6)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : userInfo?.MCID === 45
                ? chargetype
                    ?.filter((item) => item.value === 1)
                    .map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                : chargetype?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  })),
          placeholder: "Daily Rate",
          style: "",
          validationRules: [
            { required: true, message: "Charge Type is required" },
          ],
        },
      ],
      [
        {
          id: 8,
          label: "Pickup Location",
          type: "location",
          name: "plocation",
          placeholder: "Chennai",
          value: "formData.plocation",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Location is required" },
          ],
        },
        {
          id: 10,
          label: "Pickup Date & Time",
          type: "date",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          name: "pdate",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.pdate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Date & Time is required" },
          ],
        },
        {
          id: 11,
          label: "Dropoff Date & Time",
          type: "date",
          name: "ddate",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.ddate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Dropoff Date & Time is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const pickup = getFieldValue("pdate");
                if (!value || !pickup) return Promise.resolve();

                if (dayjs(value).isAfter(dayjs(pickup))) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    "Drop-off Date & Time must be later than Pick-up Date & Time.",
                  ),
                );
              },
            }),
          ],
        },
        {
          id: 5,
          label: "Priority",
          type: "selectwithvalue",
          name: "priority",
          disabled: userInfo?.MCID === 45,
          options:
            userInfo?.MCID === 46 || userInfo?.MCID === 45
              ? priorityType
                  ?.filter((item) => item.value === 1)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : priorityType?.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
          placeholder: "High",
          style: "",
          validationRules: [
            { required: true, message: "Priority is required" },
          ],
        },
      ],
      [
        {
          id: 20,
          label: "Driver",
          type: "selectwithvalue",
          name: "driver",
          placeholder: "Enter Driver",
          options: driverWithVehicle?.map((item) => ({
            value: item.VEHID,
            label: `${item.REGNO}-${item?.DriverName || ""}`,
          })),
          validationRules: [{ required: true, message: "Driver is required" }],
        },

        {
          id: 3,
          label: "Consignee",
          type: "addlist",
          name: "consignee",
          options: consigneeList?.map((item) => ({
            label: item.Name,
            value: item.ID,
          })),
          placeholder: "",
          // style: { width: "45% !important" },
          style: { width: "100% !important" },
          validationRules: [
            { required: true, message: "Consignee is required" },
          ],
          customFields: mappedConsigneeCustomFields,
          colSpan: 12,
        },
      ],
    ];
    const allFields = [...staticFields];
    const pageColSpans = allFields.map((row) =>
      row.map(
        (field) => field.colSpan || (field.name === "consignee" ? 12 : 6),
      ),
    );

    // Corrected logic to generate class names for the form pages
    const pageClassNames = allFields.map((row) =>
      row.map((field) => (field.name === "consignee" ? "consignee-list" : "")),
    );
    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: pageColSpans,
          className: pageClassNames,
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData, formData.consignee]);

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];

  const ModalForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [6],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Consign Code</span>,
              type: "text",
              name: "code",
              placeholder: "Enter Consign Code",
              maxLength: 50,
              // options: consignerList?.map((item) => ({
              //   value: item.Name,
              //   label:item.ID,
              // })),
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Consignor</span>,
              type: "selectwithvalue",
              name: "consignor",
              placeholder: "GCS",
              maxLength: 50,
              options: consignerList?.map((item) => ({
                value: item.ID,
                label: item.Name,
              })),
            },
            {
              id: 3,
              label: <span style={{ color: "#5F6D8C" }}>Transporter</span>,
              type: "selectwithvalue",
              name: "transporter",
              placeholder: "Cargo",
              maxLength: 50,
              options: transporterList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
            },
            {
              id: 4,
              label: <span style={{ color: "#5F6D8C" }}>Consignee</span>,
              type: "selectwithvalue",
              name: "consignee",
              placeholder: "TQS Agency",
              maxLength: 50,
              options: consigneeList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
            },
          ],

          [
            {
              id: 3,
              label: <span style={{ color: "#5F6D8C" }}>Duration</span>,
              type: "selectwithvalue",
              name: "duration",

              placeholder: "Current Month",
              maxLength: 50,
              options: Duration?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 4,
              label: <span style={{ color: "#5F6D8C" }}>Date Range</span>,
              type: "daterange",
              name: "daterange",
              placeholder: ["Start Date", "End Date"],
            },
            {
              id: 7,
              label: (
                <span style={{ color: "#5F6D8C" }}>Consignment Event</span>
              ),
              type: "selectwithvalue",
              name: "event",
              placeholder: "Accepted",
              maxLength: 50,
              options: EventType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
            },
          ],
          [
            {
              id: 9,
              label: <span style={{ color: "#5F6D8C" }}>Driver</span>,
              type: "selectwithvalue",
              name: "driver",
              placeholder: "Tony",
              maxLength: 50,
              options: driverList?.map((item) => ({
                value: item.UID,
                label: item.FULLNM,
              })),
            },
            {
              id: 6,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle</span>,
              type: "selectwithvalue",
              name: "vehicle",
              placeholder: "KA12345",
              options: vehicleList?.map((item) => ({
                value: item.VEHID,
                label: item.REGNO,
              })),
              allowClear: true,
            },
            {
              id: 7,
              label: <span style={{ color: "#5F6D8C" }}>Town</span>,
              type: "selectwithvalue",
              name: "town",
              placeholder: "Bern",
              maxLength: 50,
              options: (Array.isArray(countryList) ? countryList : []).map(
                (item) => ({
                  value: item.NAME,
                  label: item.VEHID,
                }),
              ),
            },
            // {
            //   id: 8,
            //   label: <span style={{ color: "#5F6D8C" }}>Container No</span>,
            //   type: "text",
            //   name: "containerno",
            //   placeholder: "",
            //   maxLength: 50,
            // },
          ],
        ],
      },
    ],
  };

  const handleSelectChange = (value, field, fields, index = 0) => {
    if (fields === "list") {
      setFormData((prevData) => {
        const updatedList = [...(prevData[field] || [])];
        while (updatedList.length <= index) {
          updatedList.push(undefined);
        }
        updatedList[index] = value;
        return { ...prevData, [field]: updatedList };
      });
    } else if (fields === "list-add") {
      setFormData((prevData) => ({
        ...prevData,
        [field]: [...(prevData[field] || []), undefined],
      }));
    } else if (fields === "list-remove") {
      setFormData((prevData) => {
        const updatedList = [...(prevData[field] || [])];
        updatedList.splice(index, 1);
        return {
          ...prevData,
          [field]: updatedList.length ? updatedList : [undefined],
        };
      });
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
  };

  // const handleUpload = async (file) => {
  //   const formData = new FormData();
  //   formData.append("file", file); // 'file' is the key your backend will expect

  //   try {
  //     setLoading(true);
  //     const response = await axios.post(
  //       "https://7gyutppcwl.execute-api.us-east-1.amazonaws.com/Prod/consignments/import",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       message.success("CSV imported successfully!");
  //       getAssignedConsignments();
  //       setLoading(false);
  //     } else {
  //       message.error("Failed to import CSV.");
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Upload error:", error);
  //     message.error("Something went wrong during upload.");
  //   }

  //   return false; // Prevent default upload behavior
  // };

  // Debugging: Log updated formData
  useEffect(() => {
    getAssignedConsignments();
    const count = Object?.values(filterData)?.filter(
      (val) => val && val.length !== 0,
    )?.length;

    setFilterCount(count - 1);
  }, [filterData, currentPage, pageSize, activeTab]);

  useEffect(() => {
    if (customFields.length && selectedCustomColumns.length === 0) {
      setSelectedCustomColumns(customFields.map((f) => String(f.CFID)));
    }
  }, [customFields]);
  useEffect(() => {
    const fetchAllCustomFields = async () => {
      setLoading(true);
      try {
        const [dataAIBulkcreate] = await Promise.all([
          CALL_API("POST", `mastertable/GetByReftab`, {
            ReftableId: "BulkCreate",
            RefId: 0,
            Active: 1,
            McId: userInfo?.MCID,
          }),
        ]);
        // Merge and deduplicate by CFID
        const allFields = [
          // ...(Array.isArray(dataAICONSIGN?.data) ? dataAICONSIGN.data : []),
          ...(Array.isArray(dataAIBulkcreate?.data)
            ? dataAIBulkcreate.data
            : []),
        ];
        // Only set empty if both are truly empty
        if (allFields.length === 0) {
          setCustomFields([]);
        } else {
          const uniqueFields = Object.values(
            allFields.reduce((acc, field) => {
              acc[field.CFID] = field;
              return acc;
            }, {}),
          );
          setCustomFields(uniqueFields);
        }
      } catch (error) {
        // Only clear if both failed
        setCustomFields([]);
        console.error("Error fetching custom fields:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllCustomFields();
    // GetAllCustomeData("AICONSIGN");
    GetAllCustomeData("BulkCreate");
  }, []);
  const BulkCreateForm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name: field.CFID,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[field.CFID],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const staticFields = [
      [
        {
          id: 1,
          label: "Consignor",
          type: "selectwithvalue",
          name: "consignor",
          placeholder: "",
          disabled: userInfo?.MCID === 45,
          options:
            userInfo?.MCID === 46
              ? consignerList
                  ?.filter((item) => item.ID === 32921)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 45
                ? consignerList
                    ?.filter((item) => item.ID === 29727)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          maxLength: 50,
          style: "",
          validationRules: [
            { required: true, message: "Consignor is required" },
          ],
        },
        {
          id: 2,
          label: "Transporter",
          type: "selectwithvalue",
          name: "transporter",
          placeholder: "Cargo",
          disabled: userInfo?.MCID === 45,
          options:
            userInfo?.MCID === 46
              ? transporterList
                  ?.filter((item) => item.ID === 32922)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 45
                ? transporterList
                    ?.filter((item) => item.ID === 29728)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          style: "",
          validationRules: [
            { required: true, message: "Transporter is required" },
          ],
        },
        {
          id: 3,
          label: "Consignee",
          type: "selectwithvalue",
          name: "consignee",
          options: consigneeList?.map((item) => ({
            label: item.Name,
            value: item.ID,
          })),
          placeholder: "TQS Agency",
          style: "",
          validationRules: [
            { required: true, message: "Consignee is required" },
          ],
        },
        {
          id: 4,
          label: "Charge Type",
          type: "selectwithvalue",
          name: "chargetype",
          disabled: userInfo?.MCID === 45,
          options:
            userInfo?.MCID === 46
              ? chargetype
                  ?.filter((item) => item.value === 6)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : userInfo?.MCID === 45
                ? chargetype
                    ?.filter((item) => item.value === 1)
                    .map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                : chargetype?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  })),
          placeholder: "Daily Rate",
          style: "",
          validationRules: [
            { required: true, message: "Charge Type is required" },
          ],
        },
      ],

      [
        {
          id: 5,
          label: "Priority",
          type: "selectwithvalue",
          name: "priority",
          disabled: userInfo?.MCID === 45,
          options: priorityType?.map((item) => ({
            label: item.name,
            value: item.value,
          })),
          options:
            userInfo?.MCID === 46 || userInfo?.MCID == 45
              ? priorityType
                  ?.filter((item) => item.value === 1)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : priorityType?.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
          placeholder: "High",
          style: "",
          validationRules: [
            { required: true, message: "Priority is required" },
          ],
        },
        {
          id: 6,
          label: "Gross Weight (in Kg)",
          type: "text",
          name: "gross",
          placeholder: "200",
          style: "",
        },
        {
          id: 7,
          label: "Pickup Location",
          type: "location",
          name: "plocation",
          placeholder: "Chennai",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Location is required" },
          ],
        },
        {
          id: 8,
          label: "Dropoff Location",
          type: "location",
          name: "dlocation",
          placeholder: "Chennai",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "dropoff Location is required" },
          ],
        },
      ],
      [
        {
          id: 9,
          label: "Delivery Pin",
          type: "switch",
          name: "switch",
        },
        {
          id: 10,

          label: "Pickup Date & Time",
          type: "date",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          name: "pdate",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.pdate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Date & Time is required" },
          ],
        },
        {
          id: 11,
          label: "Dropoff Date & Time",
          type: "date",
          name: "ddate",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.ddate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Dropoff Date & Time is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const pickup = getFieldValue("pdate");
                if (!value || !pickup) return Promise.resolve();

                if (dayjs(value).isAfter(dayjs(pickup))) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    "Drop-off Date & Time must be later than Pick-up Date & Time.",
                  ),
                );
              },
            }),
          ],
        },
        {
          id: 12,
          label: "Pickup Notes",
          type: "text",
          name: "pickupnotes",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Priority is required" },
          ],
        },
      ],
      [
        {
          id: 13,
          label: "Dropoff Notes",
          type: "text",
          name: "dropoffnotes",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Dropoff Notes is required" },
          ],
        },
        {
          id: 14,
          label: "Remarks",
          type: "text",
          name: "remark",
          placeholder: "",
          style: "",
          validationRules: [{ message: "Remarks is required" }],
        },
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) => {
        return row.some((field) => Object.keys(field).length > 0);
      }),
    ];
    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);
  const AssignModal = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle-Driver</span>,
              type: "select",
              name: "driver",
              placeholder: "KA2313- Dev Edward",
              maxLength: 50,
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Trip Code</span>,
              type: "select",
              name: "tripcode",
              placeholder: "9123",
              maxLength: 50,
            },
          ],
        ],
      },
    ],
  };

  const locationClick = (name, initialLocation = null) => {
    setSelectedItem(name);
    setInitialLocation(initialLocation);
    setLocationModal(true);
  };

  const handleclick = (record) => {
    setConsignee(true);
    setConsignmentDetails(record);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    const { data } = await CALL_API(
      "Delete",
      `consignment/delete_consignment/${id}`,
    );

    await CustomeDataDelete(reftab, id);
    setConsignee(false);
    GetAllCustomeData(reftab);
    getAssignedConsignments();

    setLoading(false);
    message.success("Consignment Deleted Successfully");
  };

  const handleBulkDelete = async () => {
    setLoading(true);
    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `consignment/bulk_delete_consignment`,
        { consignIds: selectedRowKeys },
      );

      if (ResponseCode && ResponseCode !== 200) {
        message.error(data || "Failed to delete consignments.");
        return;
      }

      for (const id of selectedRowKeys) {
        await CustomeDataDelete(reftab, id);
      }
      setConsignee(false);
      GetAllCustomeData(reftab);
      await getAssignedConsignments();
      setIsBulkDeleteModalVisible(false);
      clearSelection();
      message.success("Consignments Deleted Successfully");
    } catch (error) {
      console.error("[handleBulkDelete] error -->", error);
      message.error("Failed to delete consignments. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getsingleConsigneeData = async (id) => {
    try {
      const { data } = await CALL_API("GET", `entity/getbyId?id=${id}`);
      return data;
    } catch (error) {
      return null;
    }
  };

  const bulkSubmit = async (values) => {
    setLoading(true);
    const consigneeListWithCustomFields = values?.consignee || [];
    const customFieldDefinitions = mappedConsigneeCustomFields;

    try {
      // Generate payload asynchronously
      const consigneeData = await Promise.all(
        formData?.consignee?.map(async (item, index) => {
          const consigneeId =
            typeof item === "object" && item !== null
              ? Object.values(item)[0]
              : item;
          const data = await getsingleConsigneeData(consigneeId);

          return {
            McId: userInfo?.MCID,
            Cust: formData?.consignor,
            Shipper: formData?.transporter,
            Receiver: data?.ENTID,
            StartLocation: formData?.plocationname?.place_name || "",
            StartLat: formData?.plocationname?.latitude || 0,
            StartLng: formData?.plocationname?.longitude || 0,
            EndLocation: data?.ADDRESS || "",
            EndLat: data?.LATITUDE || 0,
            EndLng: data?.LONGITUDE || 0,
            GrossWeight: 0,
            GrossVolume: 0,
            PickUpDateTime: formData?.pdate,
            DropOffDateTime: formData?.ddate,
            ChargeType: formData?.chargetype,
            PickUpNote: formData?.pnotes,
            DropOffNote: formData?.dnotes,
            Remarks: formData?.remark,
            Priority: formData?.priority,
            CrBy: userInfo?.UID,
            ISDELOTP: false,
          };
        }),
      );

      const payload = {
        VehId: formData?.driver,
        Remarks: formData?.remark,
        Status: 0,
        userId: userInfo?.UID,
        TripType: formData?.triptype,
        Consignments: consigneeData,
      };

      const { data, ResponseCode } = await CALL_API(
        "POST",
        `consignment/bulk_create_consignment`,
        payload,
      );
      if (ResponseCode === 400) {
        message.warning(data);
        setLoading(false);
        return;
      }
      if (Array.isArray(data?.consignmentIds)) {
        // Save all custom fields
        const allCustomFieldPromises = [];

        for (let i = 0; i < data.consignmentIds.length; i++) {
          const ConsignId = data.consignmentIds[i];
          if (!ConsignId) continue;

          for (const cfDef of customFieldDefinitions) {
            const CUSTOM_FIELD_NAME = cfDef.name;
            const CUSTOM_FIELD_ID = cfDef.id;

            const customFieldValue =
              formData?.customData?.[CUSTOM_FIELD_NAME]?.[i];

            if (
              customFieldValue !== undefined &&
              customFieldValue !== null &&
              customFieldValue !== ""
            ) {
              const customFieldDataToSave = {
                CFID: Number(CUSTOM_FIELD_ID),
                RefId: Number(ConsignId),
                RefTable: reftab,
                Value:
                  typeof customFieldValue === "boolean"
                    ? customFieldValue
                      ? "True"
                      : "False" // "1" or "0"
                    : customFieldValue,
              };

              // Collect all promises
              allCustomFieldPromises.push(
                CustomeDataCreate(reftab, ConsignId, customFieldDataToSave),
              );
            }
          }
        }
        await Promise.all(allCustomFieldPromises);
        // Fetch BOTH reftabs fresh simultaneously
        const [latestConsign, latestBulkCreate] = await Promise.all([
          CALL_API(
            "GET",
            `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Consign`,
          ).then((r) => r.data),
          CALL_API(
            "GET",
            `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=BulkCreate`,
          ).then((r) => r.data),
        ]);
        setAllCustomDataConsign(latestConsign);
        setAllCustomDataBulkCreate(latestBulkCreate);

        await getAssignedConsignments({
          consign: latestConsign,
          bulkCreate: latestBulkCreate,
        });
        if (ResponseCode === 200) {
          message.success("Consignment created successfully");
        }
        handleCancel();
      } else {
        message.error("Consignment creation failed.");
      }
    } catch (error) {
      console.error("Error in bulkSubmit:", error);
      message.error("Error occurred while creating consignment");
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitForm = async (values) => {
    try {
      const commonPayload = {
        ChargeType: formData?.chargetype,
        Cust: formData?.consignor,
        DropOffDateTime: formData?.ddate,
        DropOffNote: formData?.dropoffnotes || "",
        GrossVolume: formData?.gross || 0,
        GrossWeight: formData?.gross || 0,
        ISDELOTP: formData?.switch,
        PickUpDateTime: formData?.pdate,
        PickUpNote: formData?.pickupnotes,
        Priority: formData?.priority,
        Receiver: formData?.consignee,
        Remarks: formData?.remark,
        Shipper: formData?.transporter,
        StartLat: formData?.plocationname?.latitude || 0,
        StartLng: formData?.plocationname?.longitude || 0,
        EndLat: formData?.dlocationname?.latitude || 0,
        EndLng: formData?.dlocationname?.longitude || 0,
        StartLocation: formData?.plocationname?.place_name || "",
        EndLocation: formData?.dlocationname?.place_name || "",
        McId: userInfo?.MCID,
      };

      const payload = {
        ...commonPayload,
        TripId: null,
        CrBy: userInfo?.UID,
      };

      const updatepayload = {
        ...commonPayload,
        TripId: formData?.TripId,
        CrBy: formData?.CrBy,
        ConsignId: formData?.ConsignId,
        ISDELOTP: formData?.switch,
      };
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        isEdit ? "PATCH" : "POST",
        isEdit
          ? `consignment/update_consignment`
          : `consignment/create_consignment`,
        isEdit ? updatepayload : payload,
      );

      const ConsignId = isEdit
        ? formData?.ConsignId
        : data?.ConsignId || data?.CONSIGNID || data?.result?.CONSIGNID;

      if (ConsignId) {
        if (!isEdit) {
          await SingleCustomeDataCreate(reftab, ConsignId, values);
        } else {
          await CustomeDataUpdate(reftab, ConsignId, values);
        }
      } else {
        console.error("ConsignId not found in API response:", data);
      }
      if (ResponseCode !== 200) {
        message.error("Something went wrong. Please try again.");
        return;
      }
      // Fetch BOTH reftabs fresh simultaneously
      const [latestConsign, latestBulkCreate] = await Promise.all([
        CALL_API(
          "GET",
          `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Consign`,
        ).then((r) => r.data),
        CALL_API(
          "GET",
          `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=BulkCreate`,
        ).then((r) => r.data),
      ]);
      setAllCustomDataConsign(latestConsign);
      setAllCustomDataBulkCreate(latestBulkCreate);

      await getAssignedConsignments({
        consign: latestConsign,
        bulkCreate: latestBulkCreate,
      });
      handleCancel();
      message.success(
        isEdit
          ? "Consignment updated successfully!"
          : "Consignment created successfully!",
      );
      setLoading(false);
    } catch (error) {
      console.error("[handleSubmitForm] error -->", error);
      setLoading(false);
    }
  };

  const [checkedList, setCheckedList] = useState([]);

  const onCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setSortFields(isChecked ? allOptions : []);
  };

  const allOptions = [
    "Transporterrr",
    "Locationn",
    "Order No",
    "consignorrr",
    "consignee",
  ];

  const handleSortOptionsChange = (checkedValues) => {
    setSortFields(checkedValues);
  };

  const content = (
    <WrapperBox>
      <div className="checkbox_group_container">
        <Checkbox
          indeterminate={
            sortFields.length > 0 && sortFields.length < allOptions.length
          }
          onChange={onCheckAllChange}
          checked={sortFields.length === allOptions.length}
        >
          All
        </Checkbox>

        <Checkbox.Group value={sortFields} onChange={handleSortOptionsChange}>
          <div className="checkbox_group_container">
            <Checkbox value="consignorrr">Consignor</Checkbox>
            <Checkbox value="consignee">Consignee</Checkbox>
            <Checkbox value="Transporterrr">Transporter</Checkbox>
            <Checkbox value="Locationn">Location</Checkbox>
            <Checkbox value="Order No">Order No</Checkbox>
          </div>
        </Checkbox.Group>
      </div>
    </WrapperBox>
  );
  const handleCopyClick = async () => {
    setNewLoading(true);
    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "consignment/copy",
        {
          consignId: copyId,
          McId: userInfo?.MCID,
        },
      );
      if (ResponseCode !== 200) {
        message.error("Something went wrong. Please try again later!");
      } else {
        message.success("Consignment duplicated successfully");
      }
      setIsConformationModal(false);
      setCopyId(null);
      getAssignedConsignments();
      setNewLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };
  const [value, setValue] = useState("Unassigned");

  const dropdownOne = [
    // { key: "label1", label: "Assigned" },
    // { key: "label2", label: "Unassigned" },
  ];
  const menuItems = [
    {
      key: "label1",
      label: <span onClick={() => handleTabChange("label1")}>Assigned</span>,
    },
    {
      key: "label2",
      label: <span onClick={() => handleTabChange("label2")}>Unassigned</span>,
    },
  ];

  const [dropdownselectchange, setDropdownselectchange] = useState("1");
  const handledropdownchange = (event) => {
    setDropdownselectchange(event.key);
  };
  const menu = (
    <Menu>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="1"
      >
        Event
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="2"
      >
        Files
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="3"
      >
        Comment
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="4"
      >
        Location
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="5"
      >
        KPIs
      </Menu.Item>
    </Menu>
  );

  const [width, setWidth] = useState(window.innerWidth);
  const bulkBarVisible = selectedRowKeys.length > 0 && activeTab === "label2";
  const bulkBarHeight = width < 376 ? 60 : 70; // matches .bottom-action-bar height in TableStyletwo


  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <UIModal
        width={1200}
        open={showModal}
        onClose={handlecancelmodal}
        closeButton={false}
        size="lg"
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <span className="flilter_five">Filters ({filterCount})</span>
                  {/* <span
                    style={{
                      color: "#2C963D",
                      fontWeight: "400",
                      fontSize: "20px",
                    }}
                  >
                    5 Results Found
                  </span> */}
                </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <ButtonFilled onClick={editModuleupdate}>Clear All</ButtonFilled>
          </div>
        }
      >
        {/* This is the BODY section of the Modal */}
        <WrapperBox>
          <GridBuilder
            formStructureJson={ModalForm}
            handleChange={handleFilterChange}
            formSubmit={handleSubmitForm}
            initialValues={filterData}
            handleSelectChange={handleFilterSelectChange}
            form={filterform}
          />
        </WrapperBox>
      </UIModal>
      <UIModal
        width={700}
        open={isConformationModal}
        onClose={() => {
          setIsConformationModal(false);
          setCopyId(null);
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to duplicate this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled loading={newLoading} onClick={handleCopyClick}>
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsConformationModal(false);
                setCopyId(null);
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={() => {
                handleDelete(deleteId); // Call the delete function with the selected ID
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>

      {consignee ? (
        <>
          <Consignordetails1
            // consignmentDetails={consignmentDetails}
            assignedConsignments={assignedConsignments}
            setDrawerOpen={setDrawerOpen}
            setConsignee={setConsignee}
            AddEditFormm={AddEditFormm}
            handleChange={handleChange}
            handleSubmitForm={handleSubmitForm}
            handleClose={handleClose}
            drawerOpen={drawerOpen}
            formData={formData}
            WrapperBox={WrapperBox}
            consignmentDetails={consignmentDetails}
            activeTab={activeTab}
            setFormData={setFormData}
            setIsEdit={setIsEdit}
            form={form}
            handleDelete={handleDelete}
            getAssignedConsignments={getAssignedConsignments}
            customFields={customFields}
            AllCustomeData={AllCustomeData}
            reftab={reftab}
            CustomeDataUpdate={CustomeDataUpdate}
            GetAllCustomeData={GetAllCustomeData}
          />
        </>
      ) : (
        <>
          <WrapperBox>
            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <Row gutter={16}>
                  <Col xs={24} xl={24}>
                    <Row>
                      <Col span={24}>
                        <div
                          className="Button-Wrap"
                          style={
                            window.innerWidth >= 320 && window.innerWidth <= 374
                              ? {
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexWrap: "wrap",
                                  gap: "12px",
                                  width: "100%",
                                  backgroundColor: "",
                                  marginLeft: "5px",
                                }
                              : {
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "nowrap",
                                  gap: "17px",
                                  width: "100%",
                                  marginLeft: "5px",
                                }
                          }
                        >
                          {/* --- Left side: Buttons / Dropdown --- */}
                          <div
                            className="BUTTON_trackrightai"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              minWidth: 0, // allow text truncation if needed
                            }}
                          ></div>
                        </div>
                      </Col>
                    </Row>
                    {window.innerWidth >= 320 && window.innerWidth <= 426 ? (
                      <WrapperBox>
                        <div className="reposnive_assigned_unassigned_container">
                          {/* <Dropdown
                          suffixIcon={<DownOutlined style={{color:"#2C963D"}}/>}
                            className="w-100 "
                            menu={{ items: menuItems }}
                          >
                            <ButtonOutlined
                              className="border-0 text-success"
                              style={{
                                borderRadius: "40px",
                                backgroundColor: "#E8FFEC",
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <div
                              >
                                {activeTab === "label1"
                                  ? "Assigned"
                                  : "Unassigned"}
                              </div>
                            </ButtonOutlined>
                          </Dropdown> */}
                          <Dropdown
                            suffixIcon={
                              <DownOutlined style={{ color: "#2C963D" }} />
                            } // green arrow icon
                            className="w-100" // full width
                            menu={{ items: menuItems }} // dropdown menu items
                          >
                            <ButtonOutlined
                              className="border-0 text-success"
                              style={{
                                borderRadius: "40px",
                                backgroundColor: "#E8FFEC",
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <span>
                                  {activeTab === "label1"
                                    ? "Assigned"
                                    : "Unassigned"}
                                </span>
                                <DownOutlined
                                  style={{
                                    color: "#2C963D",
                                    marginLeft: "8px",
                                  }}
                                />
                              </div>
                            </ButtonOutlined>
                          </Dropdown>

                          <div className="reposnive_assigned_unassigned_col_two">
                            <Badge
                              count={filterCount}
                              className="badg"
                              style={{ marginRight: "0px" }}
                            >
                              <Avatar
                                shape="circle"
                                size="small"
                                src={FilterIcon}
                                className="filterstyle"
                                onClick={handleclickme}
                                style={{ marginRight: "0px" }}
                              />
                            </Badge>
                            <WrapperBox>
                              <Tooltip
                                title={!createAllowed ? "No permission" : ""}
                              >
                                <Buttontransparent
                                  style={{
                                    background: "rgb(232,255,236)",
                                    cursor: createAllowed
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                  onClick={() => {
                                    if (!createAllowed) return;
                                    handleBulkCreateClick();
                                  }}
                                  className="bulk_btn"
                                >
                                  + Bulk Create
                                </Buttontransparent>
                              </Tooltip>
                            </WrapperBox>
                            <Tooltip
                              title={!createAllowed ? "No permission" : ""}
                            >
                              <ButtonFilled
                                style={{
                                  cursor: createAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={() => {
                                  if (!createAllowed) return;
                                  handleCreateClick();
                                }}
                                className="Create_btn"
                              >
                                + Create
                              </ButtonFilled>
                            </Tooltip>
                          </div>
                        </div>
                      </WrapperBox>
                    ) : (
                      <div className="container_for_assigned_unassigned">
                        <div>
                          <Tab
                            defaultActiveKey={activeTab}
                            items={[
                              { key: "label1", label: "Assigned" },
                              { key: "label2", label: "Unassigned" },
                            ]}
                            onChange={handleTabChange}
                          />
                        </div>
                        <div>
                          <div className="consingment_container">
                            <div className="consingment_container_two">
                              <div className="Custom">
                                <Tooltip
                                  title={
                                    !exportAllowed ? "No permission" : "Export"
                                  }
                                  placement="bottom"
                                  visible={visibleExport}
                                  onVisibleChange={
                                    handleTooltipVisibleChangeExport
                                  }
                                  overlayInnerStyle={{
                                    backgroundColor: "transparent",
                                    color: "#5f6d8c",
                                    boxShadow: "none",
                                    padding: "0",
                                  }}
                                >
                                  <Spin spinning={CSVLoader}>
                                    <img
                                      src={ExportIcon}
                                      alt="Export"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        cursor: exportAllowed
                                          ? "pointer"
                                          : "not-allowed",
                                        marginRight: "40px",
                                        backgroundColor: "#EBF7ED",
                                        borderRadius: "6px",
                                      }}
                                      onClick={() => {
                                        if (!exportAllowed) return;
                                        prepareCSV();
                                      }}
                                    />
                                  </Spin>
                                  <CSVLink
                                    data={CSVList}
                                    filename={"Consignment.csv"}
                                    asyncOnClick={true}
                                    ref={csvLinkEl}
                                  />
                                </Tooltip>
                              </div>
                              <div className="Custom">
                                <Tooltip
                                  title={
                                    !importAllowed ? "No permission" : "Import"
                                  }
                                  placement="bottom"
                                  visible={visibleImport}
                                  onVisibleChange={
                                    handleTooltipVisibleChangeImport
                                  }
                                  overlayInnerStyle={{
                                    backgroundColor: "transparent",
                                    color: "#5f6d8c",
                                    boxShadow: "none",
                                    padding: "0",
                                  }}
                                >
                                  <Upload
                                    beforeUpload={handleUpload}
                                    showUploadList={false}
                                    accept=".csv"
                                  >
                                    <img
                                      src={ImportIcon}
                                      alt="Import"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        cursor: importAllowed
                                          ? "pointer"
                                          : "not-allowed",
                                        marginRight: "40px",
                                        backgroundColor: "#EBF7ED",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  </Upload>
                                </Tooltip>
                              </div>
                              {/* <div className="Custom">
                              <Tooltip
                                title="Sort Column"
                                placement="bottom"
                                visible={visibleSort}
                                onVisibleChange={handleTooltipVisibleChangeSort}
                                overlayInnerStyle={{
                                  backgroundColor: "transparent",
                                  color: "#5f6d8c",
                                  boxShadow: "none",
                                  padding: "0",
                                }}
                              >
                                <Popover content={content} trigger="click">
                                  <img
                                    src={SortIcon}
                                    alt="Sort"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      cursor: "pointer",
                                      marginRight: "30px",
                                      backgroundColor: "#EBF7ED",
                                      borderRadius: "6px",
                                    }}
                                    onClick={(e) => e.preventDefault()}
                                  />
                                </Popover>
                              </Tooltip>
                            </div> */}
                              <Badge
                                count={filterCount}
                                className="badg"
                                style={{ marginRight: "20px" }}
                              >
                                <Avatar
                                  shape="circle"
                                  size="small"
                                  src={FilterIcon}
                                  className="filterstyle"
                                  onClick={handleclickme}
                                  style={{ marginRight: "20px" }}
                                />
                              </Badge>
                              <div className="Custom">
                                <Tooltip
                                  title="Sort Column"
                                  placement="bottom"
                                  visible={visibleSort}
                                  onVisibleChange={
                                    handleTooltipVisibleChangeSort
                                  }
                                  overlayInnerStyle={{
                                    backgroundColor: "transparent",
                                    color: "#5f6d8c",
                                    boxShadow: "none",
                                    padding: "0",
                                  }}
                                >
                                  <Popover content={content} trigger="click">
                                    <img
                                      src={SortIcon}
                                      alt="Sort"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        cursor: "pointer",
                                        marginRight: "30px",
                                        backgroundColor: "#EBF7ED",
                                        borderRadius: "6px",
                                      }}
                                      onClick={(e) => e.preventDefault()}
                                    />
                                  </Popover>
                                </Tooltip>
                              </div>{" "}
                              <ButtonFilled
                                onClick={() => setIsconfigModalVisible(true)}
                                className="Create_btn"
                              >
                                Configure
                              </ButtonFilled>
                              <WrapperBox>
                                <Tooltip
                                  title={!createAllowed ? "No permission" : ""}
                                >
                                  <Buttontransparent
                                    style={{
                                      background: "rgb(232,255,236)",
                                      cursor: createAllowed
                                        ? "pointer"
                                        : "not-allowed",
                                    }}
                                    onClick={() => {
                                      if (!createAllowed) return;
                                      handleBulkCreateClick();
                                    }}
                                    className="bulk_btn"
                                  >
                                    + Bulk Create
                                  </Buttontransparent>
                                </Tooltip>
                              </WrapperBox>
                              <Tooltip
                                title={!createAllowed ? "No permission" : ""}
                              >
                                <ButtonFilled
                                  style={{
                                    cursor: createAllowed
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                  onClick={() => {
                                    if (!createAllowed) return;
                                    handleCreateClick();
                                  }}
                                  className="Create_btn"
                                >
                                  + Create
                                </ButtonFilled>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <div className="consingment_container">
                  {/* <div className="consingment_container_two">
                    <div className="Custom">
                      <Tooltip
                        title="Export"
                        placement="bottom"
                        visible={visibleExport}
                        onVisibleChange={handleTooltipVisibleChangeExport}
                        overlayInnerStyle={{
                          backgroundColor: "transparent",
                          color: "#5f6d8c",
                          boxShadow: "none",
                          padding: "0",
                        }}
                      >
                        <img
                          src={ExportIcon}
                          alt="Export"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                            marginRight: "40px",
                            backgroundColor: "#EBF7ED",
                            borderRadius: "6px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="Custom">
                      <Tooltip
                        title="Import"
                        placement="bottom"
                        visible={visibleImport}
                        onVisibleChange={handleTooltipVisibleChangeImport}
                        overlayInnerStyle={{
                          backgroundColor: "transparent",
                          color: "#5f6d8c",
                          boxShadow: "none",
                          padding: "0",
                        }}
                      >
                        <Upload
                          beforeUpload={handleUpload}
                          showUploadList={false}
                          accept=".csv"
                        >
                          <img
                            src={ImportIcon}
                            alt="Import"
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              marginRight: "40px",
                              backgroundColor: "#EBF7ED",
                              borderRadius: "6px",
                            }}
                          />
                        </Upload>
                      </Tooltip>
                    </div>
                    <div className="Custom">
                      <Tooltip
                        title="Sort Column"
                        placement="bottom"
                        visible={visibleSort}
                        onVisibleChange={handleTooltipVisibleChangeSort}
                        overlayInnerStyle={{
                          backgroundColor: "transparent",
                          color: "#5f6d8c",
                          boxShadow: "none",
                          padding: "0",
                        }}
                      >
                        <Popover content={content} trigger="click">
                          <img
                            src={SortIcon}
                            alt="Sort"
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              marginRight: "30px",
                              backgroundColor: "#EBF7ED",
                              borderRadius: "6px",
                            }}
                            onClick={(e) => e.preventDefault()}
                          />
                        </Popover>
                      </Tooltip>
                    </div>
                    <Badge
                      count={filterCount}
                      className="badg"
                      style={{ marginRight: "20px" }}
                    >
                      <Avatar
                        shape="circle"
                        size="small"
                        src={FilterIcon}
                        className="filterstyle"
                        onClick={handleclickme}
                        style={{ marginRight: "20px" }}
                      />
                    </Badge>

                    <ButtonOutlined
                      onClick={handleBulkCreateClick}
                      className="bulk_btn"
                    >
                      + Bulk Create
                    </ButtonOutlined>
                    <ButtonOutlined
                      onClick={handleCreateClick}
                      className="Create_btn"
                    >
                      + Create
                    </ButtonOutlined>
                  </div> */}
                </div>
              </Col>
            </Row>
          </WrapperBox>

          <TableStyle>
            <Row gutter={16}>
              <Col xl={24} xs={24}>
                <div style={{ position: "static" }}>
                  <p className="datsource_length">{total} Consignments</p>
                  <div
                     style={{
                        marginBottom: bulkBarVisible ? `${bulkBarHeight}px` : "0px",
                      }}
                  >
                    <Spin spinning={loading || selectAllLoading}>
                      <StyledTable
                        className="fixed_height_table"
                        size="small"
                        pagination={false}
                        dataSource={assignedConsignments}
                        columns={
                          activeTab === "label2"
                            ? columnsForUnassigned
                            : columnsForAssigned
                        }
                        rowSelection={
                          activeTab === "label2" ? rowSelection : null
                        }
                        rowKey="ConsignId"
                        onRow={(record) => ({
                          onMouseEnter: () => handleClickme(record),
                          onMouseLeave: () => setHoveredrow(null),
                          onClick: () => {
                            handleclick(record);
                          },
                        })}
                      />
                      <ReusablePagination
                        pageSize={pageSize}
                        handlePageSizeChange={handlePageSizeChange}
                        currentPage={currentPage}
                        total={total}
                        handlePageChange={handlePageChange}
                      />
                    </Spin>
                  </div>

                  {/* {window.innerWidth >= 320 &&
                  window.innerWidth <= 426 ? null : (
                    <>
                      {selectedRowKeys.length > 0 && activeTab === "label2" && (
                        <div className="bottom-action-bar">
                          <BulkDelete
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsBulkDeleteModalVisible(true)}
                          />
                          <div style={{ display: "flex", gap: 16 }}>
                            <button
                              onClick={() => {
                                setSelectedRowKeys([]);
                                setSelectedRows([]);
                              }}
                            >
                              Cancel
                            </button>
                            <button onClick={() => setAssignModal(true)}>
                              + Add To Trip
                            </button>
                            <button onClick={() => setIsCreateTrip(true)}>
                              Assign Trip
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )} */}
                </div>
              </Col>
            </Row>
          </TableStyle>
        </>
      )}
      <ReusableDrawer
        title=""
        open={drawerOpen}
        setOpen={setDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={handleCancel}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              key="create"
              type="primary"
              onClick={(e) => form.submit()}
            >
              {isEdit ? "Update" : "Create"}
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignment">
                <p>
                  {isEdit
                    ? "Modifying Consignment"
                    : formType === "addEdit"
                      ? "Creating a Single Consingment"
                      : "Creating Bulk Consignment"}
                </p>

                <span>
                  <CloseOutlined onClick={handleCancel} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              {isEdit ? (
                <GridBuilder
                  formStructureJson={BulkCreateForm}
                  handleChange={handleChange}
                  formSubmit={handleSubmitForm}
                  initialValues={formData}
                  form={form}
                  locationClick={locationClick}
                  handleSelectChange={handleSelectChange}
                />
              ) : (
                // Create mode: show form based on formType
                <>
                  {formType === "addEdit" && (
                    <GridBuilder
                      formStructureJson={BulkCreateForm}
                      handleChange={handleChange}
                      formSubmit={handleSubmitForm}
                      initialValues={formData}
                      form={form}
                      locationClick={locationClick}
                      handleSelectChange={handleSelectChange}
                    />
                  )}
                  {formType === "bulkCreate" && (
                    <GridBuilder
                      formStructureJson={AddEditFormm}
                      handleChange={handleChange}
                      formSubmit={bulkSubmit}
                      initialValues={formData}
                      form={form}
                      locationClick={locationClick}
                      handleSelectChange={handleSelectChange}
                    />
                  )}
                </>
              )}
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
      <UIModal
        header="Assign Trip"
        open={assignModal}
        onClose={() => {
          setAssignModal(false);
          setAssignVehicleId(null);
        }}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              onClick={() => {
                setAssignModal(false);
                setAssignVehicleId(null);
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              onClick={() => AssignedVehicle(assignVehicleId)}
            >
              Update
            </ButtonFilled>
          </div>,
        ]}
        size="550px"
        closeButton={false}
      >
        <div className="p-3">
          <Select
            placeholder="Select Vehicle"
            value={formData.office}
            onChange={(value) => setAssignVehicleId(value)}
            style={{ width: "100%" }}
            validationRules={[
              { required: true, message: "Office is required" },
            ]}
            showSearch
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {driverWithVehicle?.map((option) => (
              <Select.Option key={option} value={option?.VEHID}>
                {`${option.REGNO}-${option?.DriverName || "-"}`}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="p-3">
          <Select
            placeholder="Select Trip Code"
            onChange={onTripCodeSelect}
            value={selectedTripCode}
            style={{ width: "100%" }}
            showSearch
            filterOption={(input, option) =>
              option?.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {Array.isArray(codeList) &&
              codeList.map((item) => (
                <Select.Option key={item.TripId} value={item.Code}>
                  {item.Code}
                </Select.Option>
              ))}
          </Select>
        </div>
      </UIModal>
      <UIModal
        width={600}
        height={600}
        open={isconfigModalVisible}
        onClose={() => {
          setIsconfigModalVisible(false);
        }}
        closeButton={false}
        size="md"
        header={
          <div className="text-start">
            <h2>Customized Column</h2>
            <label
              style={{ marginBottom: 8, display: "block", color: "#5F6D8C" }}
            >
              Columns
            </label>
          </div>
        }
        footer={
          <div className="mt-2 w-100 d-flex justify-content-end">
            <ButtonFilled
              loading={loading}
              onClick={() => {
                setIsconfigModalVisible(false);
              }}
            >
              Save
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsconfigModalVisible(false); // Just close the modal
              }}
            >
              Cancel
            </Buttontransparent>
          </div>
        }
      >
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Select custom columns"
          value={selectedCustomColumns}
          onChange={setSelectedCustomColumns}
          dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
          dropdownRender={(menu) => (
            <div>
              <Checkbox.Group
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "8px 12px",
                }}
                value={selectedCustomColumns}
                onChange={setSelectedCustomColumns}
              >
                {customFieldOptions.map((option) => (
                  <Checkbox
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                  >
                    {option.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </div>
          )}
        >
          {customFieldOptions.map((option) => (
            <Select.Option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </UIModal>
      <ReusableDrawer
        title=""
        open={isCreateTrip}
        setOpen={() => setIsCreateTrip(true)}
        onClose={() => setIsCreateTrip(false)}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={() => setIsCreateTrip(false)}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              key="create"
              type="primary"
              onClick={(e) => tripform.submit()}
            >
              Create
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Collapse>
            <Panel
              header={<span style={{ color: "green" }}>Consignment Info</span>}
              key="1"
            >
              <div style={{ height: "300px", overflowY: "auto" }}>
                <StyledTable
                  className=""
                  pagination={false}
                  dataSource={selectedRows}
                  columns={selectedColumns}
                  rowKey="ConsignId"
                  scroll={{ y: 250 }}
                />
              </div>
            </Panel>
          </Collapse>
          <Form
            form={tripform}
            layout="vertical"
            className="mt-3"
            onFinish={handleTripCreate}
            initialValues={{
              tripType:
                userInfo?.MCID === 46 || userInfo?.MCID === 55 ? 1 : undefined,
            }}
          >
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Trip Type"
                  name="tripType"
                  rules={[
                    { required: true, message: "Please select Trip Type" },
                  ]}
                  initialValue={
                    userInfo?.MCID === 46 || userInfo?.MCID === 55
                      ? 1
                      : undefined
                  }
                >
                  <Select
                    className="w-100"
                    showSearch
                    allowClear={userInfo?.MCID !== 46 || userInfo?.MCID !== 55}
                  >
                    {(userInfo?.MCID === 42
                      ? tripType.filter((type) => type.value === 1)
                      : tripType
                    ).map((type) => (
                      <Option key={type.value} value={type.value}>
                        {type.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Vehicle suitable for this consignment based on the deliverables given"
                  name="vehicle"
                  rules={[
                    { required: true, message: "Please select a vehicle" },
                  ]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) => {
                      return option?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase());
                    }}
                  >
                    {driverWithVehicle?.map((option) => (
                      <Select.Option key={option} value={option?.VEHID}>
                        {`${option.REGNO}-${option?.DriverName || ""}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                {/* Fuel Quantity */}
                <Form.Item label="Fuel Quantity" name="fuelQuantity">
                  <Input type="number" placeholder="" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Trip Allowance"
                  name="tripAllowance"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please enter the Trip Allowance",
                  //   },
                  // ]}
                >
                  <Input
                    type="number"
                    style={{ width: "100%" }}
                    defaultValue={0}
                    min={0}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={24}>
                <Form.Item label="Remark" name="remark">
                  <Input.TextArea placeholder="" rows={4} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                {tripCustomFields.map((field) => (
                  <Form.Item
                    key={field.CFID}
                    label={field.FIELDNAME}
                    name={field.FIELDNAME.replace(/\s+/g, "_").toLowerCase()}
                    rules={
                      field.REQUIRED
                        ? [
                            {
                              required: true,
                              message: `${field.FIELDNAME} is required`,
                            },
                          ]
                        : []
                    }
                  >
                    {/* Render input based on field type */}
                    <Input />
                  </Form.Item>
                ))}
              </Col>
            </Row>
          </Form>
        </WrapperBox>
      </ReusableDrawer>
      <LocationPicker
        visible={locationModal}
        onClose={() => {
          setLocationModal(false);
          setInitialLocation(null);
        }}
        onSelect={handleLocationSelect}
        initialLocation={initialLocation}
      />

      <TableStyletwo>
        <>
          {selectedRowKeys.length > 0 && activeTab === "label2" && (
            <div
              className=""
              style={{
                position: "fixed",
                bottom: "0",
                width: "97%",
                backgroundColor: "#fff",
                zIndex: "20",
                maxWidth: "-webkit-fill-available",
                overflowX: "scroll",
              }}
            >
              {width < 376 ? (
                <div className="d-flex w-100 align-items-center justify-content-between gap-3 p-2 ">
                  <div className="d-flex gap-3 overflow-x-scroll">
                    <DeleteIcon
                      style={{
                        cursor: "pointer",
                        alignSelf: "center",
                        paddingLeft: "10px",
                        width: "30px",
                        height: "30px",
                      }}
                      onClick={() => setIsBulkDeleteModalVisible(true)}
                    />
                    <Buttontransparent
                      className="footer-btn "
                      onClick={() => {
                        setSelectedRowKeys([]);
                        setSelectedRows([]);
                      }}
                    >
                      Cancel
                    </Buttontransparent>
                    <Tooltip title={!assignAllowed ? "No permission" : ""}>
                      <Button
                        className="footer-btn  
          footer_assigntrip
          bg-success"
                        style={{ color: "#fff" }}
                        onClick={() => {
                          if (!assignAllowed) return;
                          setAssignModal(true);
                        }}
                      >
                        + Add To Trip
                      </Button>
                    </Tooltip>
                    <Tooltip title={!assignAllowed ? "No permission" : ""}>
                      <Button
                        className="footer-btn bg-success"
                        style={{ color: "#fff" }}
                        onClick={() => {
                          if (!assignAllowed) return;
                          setIsCreateTrip(true);
                        }}
                      >
                        Assign Trip
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              ) : (
                <div className="d-flex w-100 align-items-center justify-content-between gap-3 p-2">
                  <div className="d-flex gap-3">
                    <span style={{ alignSelf: "center", color: "#5F6D8C" }}>
                      {selectedRowKeys.length} selected
                    </span>
                  <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                    <DeleteIcon
                      style={{
                        cursor: deleteAllowed ? "pointer" : "not-allowed",
                        alignSelf: "center",
                        paddingLeft: "10px",
                        width: "30px",
                        height: "30px",
                      }}
                      onClick={() => {
                        if (!deleteAllowed) return;
                        setIsBulkDeleteModalVisible(true);
                      }}
                    />
                  </Tooltip>
                      </div>
                  <div className="d-flex gap-3">
                    <Buttontransparent
                      className="footer-btn "
                      onClick={() => {
                        setSelectedRowKeys([]);
                        setSelectedRows([]);
                      }}
                    >
                      Cancel
                    </Buttontransparent>
                    <Tooltip title={!assignAllowed ? "No permission" : ""}>
                      <Button
                        className="footer-btn  
          footer_assigntrip
          bg-success"
                        style={{ color: "#fff" }}
                        onClick={() => {
                          if (!assignAllowed) return;
                          setAssignModal(true);
                        }}
                      >
                        + Add To Trip
                      </Button>
                    </Tooltip>
                    <Tooltip title={!assignAllowed ? "No permission" : ""}>
                      <Button
                        className="footer-btn bg-success"
                        style={{ color: "#fff" }}
                        onClick={() => {
                          if (!assignAllowed) return;
                          setIsCreateTrip(true);
                        }}
                      >
                        Assign Trip
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              )}
              {/* <div className="d-flex w-100 align-items-center justify-content-between gap-3 p-2">
                <DeleteIcon
                  style={{
                    cursor: "pointer",
                    alignSelf: "center",
                    paddingLeft: "10px",
                    width: "30px",
                    height: "30px",
                  }}
                  onClick={() => setIsBulkDeleteModalVisible(true)}
                />
                <div className="d-flex gap-3">
                  <Button
                    className="footer-btn "
                    onClick={() => {
                      setSelectedRowKeys([]);
                      setSelectedRows([]);
                    }}
                  >
                    Cancell
                  </Button>
                  <Button
                    className="footer-btn  
          footer_assigntrip
          bg-success"
                    style={{ color: "#fff" }}
                    onClick={() => setAssignModal(true)}
                  >
                    + Add To Trip
                  </Button>
                  <Button
                    className="footer-btn bg-success"
                    style={{ color: "#fff" }}
                    onClick={() => setIsCreateTrip(true)}
                  >
                    Assign Trip
                  </Button>
                </div>
              </div> */}
            </div>
          )}
        </>
      </TableStyletwo>
      <UIModal
        width={500}
        open={isBulkDeleteModalVisible}
        onClose={() => setIsBulkDeleteModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <GeoDelete />
          <h4>Delete Consignments?</h4>
          <p>
            This action will permanently delete the selected consignments.
            <br />
            Do you want to proceed?
          </p>{" "}
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleBulkDelete} // Call the delete function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsBulkDeleteModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
    </>
  );
};

export default Consignment1;
// Place this at the top of your file
const reverseGeocode = async (lat, lng) => {
  if (!lat || !lng) return "-";
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
    );
    const data = await response.json();
    return data.display_name || "-";
  } catch (error) {
    return "-";
  }
};
// Place this at the top of your file or in a separate file
const LocationCell = ({
  startLat,
  startLng,
  endLat,
  endLng,
  locationCache,
  setLocationCache,
  renderText,
}) => {
  const [startAddress, setStartAddress] = useState(
    locationCache[`${startLat},${startLng}`],
  );
  const [endAddress, setEndAddress] = useState(
    locationCache[`${endLat},${endLng}`],
  );

  useEffect(() => {
    const startKey = `${startLat},${startLng}`;
    const endKey = `${endLat},${endLng}`;

    if (startLat && startLng && !locationCache[startKey]) {
      reverseGeocode(startLat, startLng).then((address) => {
        setLocationCache((prev) => ({ ...prev, [startKey]: address }));
        setStartAddress(address);
      });
    }

    if (endLat && endLng && !locationCache[endKey]) {
      reverseGeocode(endLat, endLng).then((address) => {
        setLocationCache((prev) => ({ ...prev, [endKey]: address }));
        setEndAddress(address);
      });
    }
    // eslint-disable-next-line
  }, [startLat, startLng, endLat, endLng]);

  const start = startAddress || locationCache[`${startLat},${startLng}`] || "-";
  const end = endAddress || locationCache[`${endLat},${endLng}`] || "-";

  const locationText = `${end}`;

  // apply your reusable render logic
  if (renderText) {
    return renderText(locationText);
  }

  return <span>{locationText}</span>;
};
